import React, { useEffect, useState } from "react";
// import { auth } from "../firebase";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import ProductSelectionStep from "../components/orders/ProductSelectionStep";
import ProductSelectionModal from "../components/orders/ProductSelectionModal";
import { db, auth } from '../firebase';
import { collection, getDoc,getDocs, addDoc, updateDoc, doc as firestoreDoc, Timestamp } from 'firebase/firestore';
import {toast } from 'react-toastify';
import {
  FaSearch,
  FaCalendarAlt,
  FaFilter,
  FaDownload,
  FaEye,
  FaTimes,
  FaUser,
  FaMapMarkerAlt,
  FaPhone,
  FaEnvelope,
  FaBox,
  FaTruck,
  FaPlane,
  FaMoneyBillWave,
  FaEllipsisH,
} from "react-icons/fa";

const OrderManagement = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [rtoActiveTab, setRtoActiveTab] = useState("inventory");
const [returnLogs, setReturnLogs] = useState([]);
const [returnLogsLoading, setReturnLogsLoading] = useState(false);
const [returnLogsHasMore, setReturnLogsHasMore] = useState(true);
const [returnLogsLoadingMore, setReturnLogsLoadingMore] = useState(false);

const [returnLogsOldestDate, setReturnLogsOldestDate] = useState(null);

  const [tabData, setTabData] = useState({
    // Each tab will have its own data and pagination state
    all: { orders: [], lastVisible: null, hasMore: true, loading: false },
    pending: { orders: [], lastVisible: null, hasMore: true, loading: false },
    "in-transit": {
      orders: [],
      lastVisible: null,
      hasMore: true,
      loading: false,
    },
    delivered: { orders: [], lastVisible: null, hasMore: true, loading: false },
    ndr: { orders: [], lastVisible: null, hasMore: true, loading: false },
    rto: { orders: [], lastVisible: null, hasMore: true, loading: false },
    returns: { orders: [], lastVisible: null, hasMore: true, loading: false },
    cancelled: { orders: [], lastVisible: null, hasMore: true, loading: false },
    "return-inventory": {
      orders: [],
      lastVisible: null,
      hasMore: true,
      loading: false,
    },
  });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [paymentMethodFilter, setPaymentMethodFilter] = useState("all");
  const [lastVisible, setLastVisible] = useState(null);
  const [loadingMore, setLoadingMore] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [searchLoading, setSearchLoading] = useState(false);

  const [rtoInventory, setRtoInventory] = useState([]);
  const [rtoLoading, setRtoLoading] = useState(false);

  const [error, setError] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [orderDetailLoading, setOrderDetailLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [returnLoading, setReturnLoading] = useState(false);
  const [showReturnModal, setShowReturnModal] = useState(false);
  const [returnFormData, setReturnFormData] = useState({
    pickup_customer_name: "",
    pickup_phone: "",
    pickup_email: "",
    pickup_address: "",
    pickup_address_2: "",
    pickup_pincode: "",
    pickup_city: "",
    pickup_state: "",
    return_reason_id: "5",
    customer_request: "REFUND",
    reason_comment: "",
    selected_items: [],
  });

  // Add a new state variable for return orders
  const [returnOrders, setReturnOrders] = useState([]);
  const [returnOrdersLastVisible, setReturnOrdersLastVisible] = useState(null);
  const [returnOrdersLoading, setReturnOrdersLoading] = useState(false);
  const [returnOrdersHasMore, setReturnOrdersHasMore] = useState(true);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const shopId = queryParams.get("shop");
  const ordersPerPage = 50;

  // Add these constants near the top of your component
const RETURN_COST = 100;
const TAX_RATE = 0.18;
const TOTAL_COST = RETURN_COST + (RETURN_COST * TAX_RATE);

// Add these state variables to your component state
const [walletBalance, setWalletBalance] = useState(0);
const [showConfirmModal, setShowConfirmModal] = useState(false);
const [confirmBalance, setConfirmBalance] = useState(0);
 const [isModalOpen, setIsModalOpen] = useState(false);

  // Size Exchange states
  const [showSizeExchangeModal, setShowSizeExchangeModal] = useState(false);
  const [sizeExchangeLoading, setSizeExchangeLoading] = useState(false);
  const [sizeExchangeFormData, setSizeExchangeFormData] = useState({
    selected_items: [],
  });
  const [showSizeExchangeConfirmModal, setShowSizeExchangeConfirmModal] = useState(false);
  const [sizeExchangeAmount, setSizeExchangeAmount] = useState(0);
  const [sizeExchangeBreakdown, setSizeExchangeBreakdown] = useState({
    itemsSubtotal: 0,
    tax5: 0,
    shippingShare: 0,
    shippingGst18: 0,
    returnCostWithTax: 0,
    total: 0,
  });
  const [exchangeShippingPreference, setExchangeShippingPreference] = useState("");
  
  // Product Exchange states
  const [showProductExchangeModal, setShowProductExchangeModal] = useState(false);
  const [productExchangeLoading, setProductExchangeLoading] = useState(false);
  const [productExchangeFormData, setProductExchangeFormData] = useState({
    selected_items: [],
    exchange_products: [],
  });
  const [showProductExchangeConfirmModal, setShowProductExchangeConfirmModal] = useState(false);
  const [productExchangeAmount, setProductExchangeAmount] = useState(0);
  const [productExchangeBreakdown, setProductExchangeBreakdown] = useState({
    itemsSubtotal: 0,
    tax5: 0,
    shippingShare: 0,
    shippingGst18: 0,
    returnCostWithTax: 0,
    total: 0,
  });
  const [selectedExchangeProducts, setSelectedExchangeProducts] = useState([]);
  const [exchangeShippingMethod, setExchangeShippingMethod] = useState('Surface');
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [exchangeProducts, setExchangeProducts] = useState([]);
   const [neckLabelsEnabled, setNeckLabelsEnabled] = useState(false);
  const [productsLoading, setProductsLoading] = useState(false);
  
    // Compute size exchange breakdown for given items and shipping method (using same logic as product exchange)
  const computeSizeExchangeBreakdown = (itemsForExchange, order, shippingPrefOverride) => {
    const selected = (itemsForExchange || []).filter(
      (item) => item.selected && item.new_size && item.new_size !== (item.size || item.variant_size || '')
    );
    if (selected.length === 0 || !order) {
      return { 
        itemsSubtotal: 0, 
        neckLabelTotal: 0,
        tax5: 0, 
        baseShipping: 0,
        codShipping: 0,
        shippingTax: 0,
        totalShipping: 0,
        returnCostWithTax: parseFloat(TOTAL_COST.toFixed(2)), 
        total: parseFloat(TOTAL_COST.toFixed(2)) 
      };
    }

// Calculate items subtotal and neck label total separately (same as product exchange)
    let itemsSubtotal = 0;
    let neckLabelTotal = 0;
    
    selected.forEach(item => {
      const designTotalPrice = getDesignTotalPrice(item);
      const neckLabelPrice = neckLabelsEnabled ? 5 : 0; // 5 Rs per unit if neck labels are enabled
      const quantity = parseInt(item.units) || 1;
      
      itemsSubtotal += designTotalPrice * quantity;
      neckLabelTotal += neckLabelPrice * quantity;
    });

    // Calculate 5% tax on items + neck labels (same as product exchange)
    const taxableAmount = itemsSubtotal + neckLabelTotal;
    const tax5 = parseFloat((taxableAmount * 0.05).toFixed(2));
   // Use EXACT same shipping calculation as product exchange
    const specialStates = [
      "North East", "J & K", "Ladakh", "Andaman & Nicobar", "Himachal Pradesh",
      "Sikkim", "Lakshadweep", "Arunachal Pradesh", "Assam", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Tripura"
    ];
    const billingState = order?.shipping_state || order?.billing_state;
    const effectiveShippingPref = shippingPrefOverride || order?.shippingPreference || 'Surface';
    let baseRate = 0;
    if (effectiveShippingPref === "Air") baseRate = 75;
    else if (effectiveShippingPref === "Surface") baseRate = 65;
    else baseRate = specialStates.includes(billingState) ? 85 : 65;

// Use volumetric weight calculation (same as product exchange)
    const itemWeight = 0.25; // Base weight for calculating shipping cost (same as CreateOrder)
    
    // Calculate the total weight of selected items
    let totalWeight = 0;
    for (const item of selected) {
      if (item.units && typeof item.units === "number") {
        const productWeight = item.units * itemWeight;
        totalWeight += productWeight;
      }
    }
    
    const weightGroups = Math.ceil(totalWeight / 0.5); // Group by 0.5 kg (same as CreateOrder)
    const baseShipping = baseRate * weightGroups;
// COD shipping calculation (same as product exchange)
    const paymentMethodLower = (order?.payment_method || '').toLowerCase();
    const isCODorPartial = paymentMethodLower === 'cod' || paymentMethodLower === 'partially paid' || paymentMethodLower === 'partially_paid';
    const selectedItemsSellingSubtotal = selected.reduce((sum, item) => sum + ((parseFloat(item.selling_price) || 0) * (parseInt(item.units) || 1)), 0);
     let codShipping = 0;
    if (isCODorPartial) {
      codShipping = selectedItemsSellingSubtotal > 2000 ? (selectedItemsSellingSubtotal * 0.025) : 50;  
    }
     const totalShippingCharge = baseShipping + codShipping;
    const shippingTax = parseFloat((totalShippingCharge * 0.18).toFixed(2));
    const totalShipping = parseFloat((totalShippingCharge + shippingTax).toFixed(2));
    const returnCostWithTax = parseFloat(TOTAL_COST.toFixed(2));

    const total = parseFloat((itemsSubtotal + neckLabelTotal + tax5 + totalShipping + returnCostWithTax).toFixed(2));
    
    return { 
      itemsSubtotal: parseFloat(itemsSubtotal.toFixed(2)), 
      neckLabelTotal: parseFloat(neckLabelTotal.toFixed(2)),
      tax5, 
      baseShipping: parseFloat(baseShipping.toFixed(2)),
      codShipping: parseFloat(codShipping.toFixed(2)),
      shippingTax,
      totalShipping,
      returnCostWithTax, 
      total 
    };
  };

  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }


  const fetchDesignData = async (designId) => {
    try {
      if (!designId) return null;
      
      const designRef = firestoreDoc(db, 'users', user.uid, 'designs', designId);
      const designDoc = await getDoc(designRef);
      
      if (designDoc.exists()) {
        return designDoc.data();
      }
      return null;
    } catch (error) {
      console.error('Error fetching design data:', error);
      return null;
    }
  };

  // Helper function to extract totalPrice from design data (handles both formats)
  const getDesignTotalPrice = (item, fetchedDesignData = null) => {
    // Use fetched design data if available, otherwise fall back to item design
    const design = fetchedDesignData || item.design || {};
    
    console.log('🔍 getDesignTotalPrice - Item:', item);
    console.log('🔍 getDesignTotalPrice - Item keys:', Object.keys(item));
    console.log('🔍 getDesignTotalPrice - Item baseCost:', item.baseCost);
    console.log('🔍 getDesignTotalPrice - Item PrintCost:', item.PrintCost);
    console.log('🔍 getDesignTotalPrice - Item totalPrice:', item.totalPrice);
    console.log('🔍 getDesignTotalPrice - Fetched Design Data:', fetchedDesignData);
    console.log('🔍 getDesignTotalPrice - Design (final):', design);
    
    // Check if design has colorVariants (format 1 - from Firestore designs)
    if (design.colorVariants && Array.isArray(design.colorVariants) && design.colorVariants.length > 0) {
      console.log('✅ Found colorVariants:', design.colorVariants);
      // For color variants, use the first variant's totalPrice or selected variant
      const selectedVariant = design.colorVariants.find(variant => variant.selected) || design.colorVariants[0];
      const totalPrice = parseFloat(selectedVariant?.totalPrice || 0);
      console.log('✅ Selected variant totalPrice:', totalPrice);
      return totalPrice;
    }
    
    // Check if design has direct totalPrice (format 2 - from Firestore designs)
    if (design.totalPrice !== undefined) {
      const totalPrice = parseFloat(design.totalPrice || 0);
      console.log('✅ Found direct totalPrice:', totalPrice);
      return totalPrice;
    }
    
    // For order items, check if design has baseCost and PrintCost (calculate totalPrice)
    if (design.baseCost !== undefined && design.PrintCost !== undefined) {
      const totalPrice = parseFloat(design.baseCost || 0) + parseFloat(design.PrintCost || 0);
      console.log('✅ Calculated totalPrice from baseCost + PrintCost:', totalPrice, '(baseCost:', design.baseCost, 'PrintCost:', design.PrintCost, ')');
      return totalPrice;
    }
    
    // NEW: Check if item itself has baseCost and PrintCost (for products from designs collection)
    if (item.baseCost !== undefined && item.PrintCost !== undefined) {
      const totalPrice = parseFloat(item.baseCost || 0) + parseFloat(item.PrintCost || 0);
      console.log('✅ Calculated totalPrice from item baseCost + PrintCost:', totalPrice, '(baseCost:', item.baseCost, 'PrintCost:', item.PrintCost, ')');
      return totalPrice;
    }
    
    // NEW: Check if item has direct totalPrice
    if (item.totalPrice !== undefined) {
      const totalPrice = parseFloat(item.totalPrice || 0);
      console.log('✅ Found item totalPrice:', totalPrice);
      return totalPrice;
    }
    
    // Fallback to item fields (for order items)
    const fallbackPrice = parseFloat(item.itemTotalPrice || item.unitee_total_price || item.UniteeTotalPrice || item.designTotalPrice || 0);
    console.log('⚠️ Using fallback price:', fallbackPrice, '(itemTotalPrice:', item.itemTotalPrice, 'unitee_total_price:', item.unitee_total_price, 'UniteeTotalPrice:', item.UniteeTotalPrice, 'designTotalPrice:', item.designTotalPrice, ')');
    return fallbackPrice;
  };

  // Fetch user's neckLabels setting
  useEffect(() => {
    const fetchUserNeckLabels = async () => {
      try {
        const userRef = firestoreDoc(db, 'users', user.uid);
        const userDoc = await getDoc(userRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          setNeckLabelsEnabled(data.neckLabels === true);
        }
      } catch (error) {
        console.error('Error fetching user neckLabels setting:', error);
      }
    };
    
    if (user) {
      fetchUserNeckLabels();
    }
  }, [user]);

  // Tab configurations based on tracking_status
  const tabs = [
    { id: "all", label: "All Orders", status: null },
    {
      id: "pending",
      label: "Pending",
      status: ["pending", "confirmed", "processing", "ready_to_ship"],
    },
    {
      id: "in-transit",
      label: "In Transit",
      status: ["in-transit", "out_for_delivery", "pickup_rescheduled"],
    },
    { id: "delivered", label: "Delivered", status: ["delivered"] },
    {
      id: "ndr",
      label: "NDR",
      status: ["ndr", "delivery_exception", "undelivered"],
    },
    {
      id: "rto",
      label: "RTO",
      status: [
        "rto",
        "rto_in_transit",
        "rto_delivered",
        "return to origin",
        "rto delivered",
      ],
    },
    {
      id: "returns",
      label: "Returns",
      status: ["return_initiated", "return_delivered"],
    },
    {
      id: "cancelled",
      label: "Cancelled",
      status: ["canceled", "cancelled"],
    },
    {
      id: "return-inventory",
      label: "Return Inventory",
      status: null,
    },
  ];
  // Function to fetch orders from the API
  const fetchOrdersFromApi = async (tabId, isInitialLoad = true) => {
    try {
      if (isInitialLoad) {
        setLoading(true);
        setOrders([]);
        setError(null);
        setLastVisible(null);
      } else {
        setLoadingMore(true);
      }

      const token = await user.getIdToken();
      const url = new URL(
        `https://ufb-1.onrender.com/api/orders/users/${user.uid}/orders/tab/${tabId}`
      );
      url.searchParams.set("limit", "50"); // Changed to 50 as requested

      if (!isInitialLoad && lastVisible) {
        url.searchParams.set("lastDoc", lastVisible);
      }

      // Add filters to URL
      if (paymentMethodFilter !== "all") {
        url.searchParams.set("paymentMethod", paymentMethodFilter);
      }
      if (startDate) {
        url.searchParams.set("startDate", startDate);
      }
      if (endDate) {
        url.searchParams.set("endDate", endDate);
      }

      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!res.ok) throw new Error("Failed to fetch orders");

      const data = await res.json();
      const fetchedOrders = data.orders || [];

      if (isInitialLoad) {
        setOrders(fetchedOrders);
      } else {
        setOrders((prev) => [...prev, ...fetchedOrders]);
      }

      setLastVisible(data.lastVisible);
      setHasMore(data.hasMore);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError(`Error fetching orders: ${error.message}`);
    } finally {
      setLoading(false);
      setLoadingMore(false);
    }
  };

  // Function to fetch return orders from the API
const fetchReturnOrdersFromApi = async (isInitialLoad = true) => {
  try {
    if (isInitialLoad) {
      setReturnOrdersLoading(true);
      setReturnOrders([]);
      setError(null);
      setReturnOrdersLastVisible(null);
    } else {
      setLoadingMore(true);
    }

    const token = await user.getIdToken();
    const url = new URL(`https://ufb-1.onrender.com/api/orders/users/${user.uid}/return-orders`);
    url.searchParams.set("limit", "50");
    
    if (!isInitialLoad && returnOrdersLastVisible) {
      url.searchParams.set("lastDoc", returnOrdersLastVisible);
    }

    // Add filters to URL
    if (paymentMethodFilter !== "all") {
      url.searchParams.set("paymentMethod", paymentMethodFilter);
    }
    if (startDate) {
      url.searchParams.set("startDate", startDate);
    }
    if (endDate) {
      url.searchParams.set("endDate", endDate);
    }

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Failed to fetch return orders");

    const data = await res.json();
    const fetchedOrders = data.orders || [];

    if (isInitialLoad) {
      setReturnOrders(fetchedOrders);
    } else {
      setReturnOrders((prev) => [...prev, ...fetchedOrders]);
    }

    setReturnOrdersLastVisible(data.lastVisible);
    setReturnOrdersHasMore(data.hasMore);
  } catch (error) {
    console.error("Error fetching return orders:", error);
    setError(`Error fetching return orders: ${error.message}`);
  } finally {
    setReturnOrdersLoading(false);
    setLoadingMore(false);
  }
};


  // Function to fetch single order details
const fetchOrderDetails = async (orderId) => {
  console.log("Fetching order details for:", orderId); // Debug log
  setOrderDetailLoading(true);
  try {
    const token = await user.getIdToken();
    let apiUrl;
    
    // Check if this is a return order or regular order
    if (activeTab === "returns" || orderId.startsWith("R_")) {
      apiUrl = `https://ufb-1.onrender.com/api/orders/users/${user.uid}/return-orders/${orderId}`;
    } else {
      apiUrl = `https://ufb-1.onrender.com/api/orders/users/${user.uid}/orders/${orderId}`;
    }
    
    const res = await fetch(apiUrl, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Failed to fetch order details");

    const data = await res.json();
    console.log("Order details fetched:", data); // Debug log
    setSelectedOrder(data.order || data); // Handle both possible response structures
    setShowModal(true);
  } catch (error) {
    console.error("Error fetching order details:", error);
    setError(`Error fetching order details: ${error.message}`);
  } finally {
    setOrderDetailLoading(false);
  }
};


  // Function to search orders from the API
const searchOrdersFromApi = async (searchValue) => {
  setSearchLoading(true);
  try {
    const token = await user.getIdToken();
    let url;
    
    if (activeTab === "returns") {
      url = new URL(`https://ufb-1.onrender.com/api/orders/users/${user.uid}/return-orders/search`);
    } else {
      url = new URL(`https://ufb-1.onrender.com/api/orders/users/${user.uid}/orders/search`);
    }
    
    url.searchParams.set("q", searchValue);

    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error(`Failed to search ${activeTab === "returns" ? "return orders" : "orders"}`);

    const data = await res.json();
    setFilteredOrders(data.orders || []);
  } catch (error) {
    console.error(`Error searching ${activeTab === "returns" ? "return orders" : "orders"}:`, error);
    setFilteredOrders([]);
  } finally {
    setSearchLoading(false);
  }
};

  // Update the search functionality to include return orders
const handleSearch = (searchValue) => {
  setSearchTerm(searchValue);

  if (searchValue.trim() === "") {
    setFilteredOrders([]);
    return;
  }

  // First search locally based on active tab
  const ordersToSearch = activeTab === "returns" ? returnOrders : orders;
  const localResults = ordersToSearch.filter((order) => {
    const term = searchValue.toLowerCase();
    
    if (activeTab === "returns") {
      // Search fields specific to return orders
      return (
        order.id?.toLowerCase().includes(term) ||
        order.order_id?.toLowerCase().includes(term) ||
        order.pickup_name?.toLowerCase().includes(term) ||
        order.pickup_email?.toLowerCase().includes(term) ||
        order.awb_code?.toLowerCase().includes(term) ||
        order.tracking_status?.toLowerCase().includes(term) ||
        order.order_items?.some(item => 
          item.sku?.toLowerCase().includes(term) || 
          item.name?.toLowerCase().includes(term)
        )
      );
    } else {
      // Search fields for regular orders
      return (
        order.id?.toLowerCase().includes(term) ||
        order.Storeorder_id?.toLowerCase().includes(term) ||
        order.billing_customer_name?.toLowerCase().includes(term)
      );
    }
  });

  if (localResults.length > 0) {
    setFilteredOrders(localResults);
  } else {
    // If nothing found locally → call API
    searchOrdersFromApi(searchValue);
  }
};

  // Add this function to determine if the selected order is a return order
  const isReturnOrder = (order) => {
    return (
      activeTab === "returns" ||
      order?.order_id?.startsWith("R_") ||
      order?.id?.startsWith("R_")
    );
  };

  // Helper function to get customer name based on order type
const getCustomerName = (order) => {
  if (activeTab === "returns" || order?.pickup_name) {
    return order.pickup_name || "N/A";
  }
  return order.billing_customer_name || "N/A";
};

// Helper function to get order ID display
const getOrderIdDisplay = (order) => {
  if (activeTab === "returns" || order?.order_id?.startsWith("R_")) {
    return order.order_id || order.id || "N/A";
  }
  return order.Storeorder_id || "N/A";
};

// Helper function to get order total
const getOrderTotal = (order) => {
  if (activeTab === "returns" || order?.order_id?.startsWith("R_")) {
    // For return orders, calculate from order_items
    return order.order_items?.reduce((total, item) => 
      total + (parseFloat(item.selling_price || 0) * (item.units || 1)), 0
    ) || 0;
  }
  return order.total || 0;
};

// Helper function to get first product SKU
const getFirstProductSku = (order) => {
  if (activeTab === "returns" || order?.order_id?.startsWith("R_")) {
    return order.order_items?.[0]?.sku || order.product_detail?.[0]?.sku_number || "N/A";
  }
  return order.order_items?.[0]?.sku || "N/A";
};


// Updated handleBookReturn function with wallet integration
const handleBookReturn = async () => {
  // Check if items are selected
  const selectedItemsForReturn = returnFormData.selected_items.filter(
    (item) => item.selected && item.return_quantity > 0
  );

  if (selectedItemsForReturn.length === 0) {
    alert("Please select at least one item to return");
    return;
  }

  // Check wallet balance
  if (walletBalance < TOTAL_COST) {
    toast.error('Insufficient balance. Recharge your wallet.', { 
      onClose: () => setIsModalOpen(true) // You'll need to add setIsModalOpen state for wallet recharge modal
    });
    return;
  }

  // Set balance after deduction and show confirmation modal
  setConfirmBalance(parseFloat((walletBalance - TOTAL_COST).toFixed(2)));
  setShowConfirmModal(true);
};

// New function to actually create the return order after confirmation
const confirmReturnOrder = async () => {
  setReturnLoading(true);
  try {
    const token = await user.getIdToken();

    // Format phone number like in working function
    let rawPhone =
      returnFormData.pickup_phone ||
      selectedOrder.shipping_phone ||
      selectedOrder.billing_phone;
    let digits = rawPhone.replace(/\D/g, "");
    if (digits.startsWith("91") && digits.length > 10) {
      digits = digits.slice(2);
    }
    const pickupPhone = digits.slice(-10);

    // Construct the return order payload
    const returnOrderData = {
      user_uid: user.uid,
      id: `R_${selectedOrder.id}`,
      order_date: new Date().toISOString().split("T")[0],

      // Pickup information
      pickup_customer_name:
        returnFormData.pickup_customer_name ||
        selectedOrder.shipping_customer_name ||
        selectedOrder.billing_customer_name,
      pickup_last_name:
        returnFormData.pickup_last_name ||
        selectedOrder.shipping_last_name ||
        selectedOrder.billing_last_name,
      pickup_address:
        returnFormData.pickup_address ||
        selectedOrder.shipping_address ||
        selectedOrder.billing_address,
      pickup_address_2:
        returnFormData.pickup_address_2 ||
        selectedOrder.shipping_address_2 ||
        selectedOrder.billing_address_2,
      pickup_city:
        returnFormData.pickup_city ||
        selectedOrder.shipping_city ||
        selectedOrder.billing_city,
      pickup_state:
        returnFormData.pickup_state ||
        selectedOrder.shipping_state ||
        selectedOrder.billing_state,
      pickup_country: selectedOrder.shipping_country || "India",
      pickup_pincode:
        returnFormData.pickup_pincode ||
        selectedOrder.shipping_pincode ||
        selectedOrder.billing_pincode,
      pickup_email:
        returnFormData.pickup_email ||
        selectedOrder.shipping_email ||
        selectedOrder.billing_email,
      pickup_phone: pickupPhone,

      // Order items
      order_items: returnFormData.selected_items
        .filter((item) => item.selected && item.return_quantity > 0)
        .map((item) => ({
          name: item.name,
          sku: item.sku,
          units: item.return_quantity,
          selling_price: item.selling_price,
        })),

      payment_method: selectedOrder.payment_method,
      sub_total: returnFormData.selected_items
        .filter((item) => item.selected && item.return_quantity > 0)
        .reduce(
          (total, item) =>
            total + parseFloat(item.selling_price) * item.return_quantity,
          0
        ),

      // Package defaults
      length: selectedOrder.length || 24,
      breadth: selectedOrder.breadth || 19,
      height: selectedOrder.height || 3,
      weight: selectedOrder.weight || 0.5,

      // Original order reference
      original_order_id: selectedOrder.id,
      shopDomain: selectedOrder.shopDomain,

      // Return-specific fields
      return_reason_id: returnFormData.return_reason_id,
      customer_request: returnFormData.customer_request,
      reason_comment: returnFormData.reason_comment,
    };

    console.log("Payload to API:", returnOrderData);

    // API call to create return order
    const response = await fetch(
      "https://ufb-1.onrender.com/shipmozo/create-shipmozo-return-order",
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(returnOrderData),
      }
    );

    if (!response.ok) {
      throw new Error("Failed to create return order");
    }

    const data = await response.json();

    if (data.success) {

      // balance update

const newBalance = parseFloat((walletBalance - TOTAL_COST).toFixed(2));
const walletRef = firestoreDoc(db, 'users', user.uid, 'wallet', 'walletDetails');
await updateDoc(walletRef, { balance: newBalance });

// Record transaction
const transactionsRef = collection(walletRef, 'transactions');
const transactionData = {
  type: `Return_${selectedOrder.id}`,
  amount: parseFloat(TOTAL_COST.toFixed(2)),
  balanceBefore: parseFloat(walletBalance.toFixed(2)),
  balanceAfter: newBalance,
  timestamp: Timestamp.now(),
};
await addDoc(transactionsRef, transactionData);

// Update local wallet balance state
setWalletBalance(newBalance);

      toast.success("Return order created successfully!");
      setShowReturnModal(false);
      setShowConfirmModal(false);
      
      // Refresh order details if needed
      fetchOrderDetails(selectedOrder.id);
    } else {
      throw new Error(data.message || "Failed to create return order");
    }
  } catch (error) {
    console.error("Error creating return order:", error);
    
    // Close confirmation modal on error
    setShowConfirmModal(false);
    
    // Show error in toast notification
    toast.error(`Failed to create return order: ${error.response?.data?.error || error.message}`);
  } finally {
    setReturnLoading(false);
  }
};


// Exchange 
const handleSizeExchange = async () => {
  // Check if items are selected
  const selectedItemsForExchange = sizeExchangeFormData.selected_items.filter(
    (item) => item.selected && item.new_size && item.new_size !== (item.size || item.variant_size || '')
  );

  if (selectedItemsForExchange.length === 0) {
    toast.error("Please select at least one item with a different size for exchange");
    return;
  }

  const breakdown = computeSizeExchangeBreakdown(sizeExchangeFormData.selected_items, selectedOrder, exchangeShippingPreference || selectedOrder?.shippingPreference);
  setSizeExchangeAmount(breakdown.total);
  setSizeExchangeBreakdown(breakdown);
  // Ensure only one modal is visible
  setShowReturnModal(false);
  setShowConfirmModal(false);
  setShowSizeExchangeModal(false);
  setShowSizeExchangeConfirmModal(true);
};

// Confirm size exchange function
const confirmSizeExchange = async () => {
  const selectedItemsForExchange = sizeExchangeFormData.selected_items.filter(
    (item) => item.selected && item.new_size && item.new_size !== (item.size || item.variant_size || '')
  );

  setSizeExchangeLoading(true);

  try {
    const token = await user.getIdToken();
    // Wallet check and deduction like returns, using computed sizeExchangeAmount
    if (walletBalance < sizeExchangeAmount) {
      toast.error('Insufficient balance. Recharge your wallet.');
      setSizeExchangeLoading(false);
      return;
    }

    // Normalize phone number similar to confirmReturnOrder
    let rawPhone = selectedOrder.shipping_phone || selectedOrder.billing_phone || '';
    let digits = (rawPhone || '').replace(/\D/g, "");
    if (digits.startsWith("91") && digits.length > 10) {
      digits = digits.slice(2);
    }
    const pickupPhone = digits.slice(-10);
    
    // First, create a return order for the original items with complete payload
    const returnData = {
      user_uid: user.uid,
      id: `R_${selectedOrder.id}`,
      order_date: new Date().toISOString().split("T")[0],

      pickup_customer_name: selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name || "",
      pickup_last_name: selectedOrder.shipping_last_name || selectedOrder.billing_last_name || "",
      pickup_address: selectedOrder.shipping_address || selectedOrder.billing_address || "",
      pickup_address_2: selectedOrder.shipping_address_2 || selectedOrder.billing_address_2 || "",
      pickup_city: selectedOrder.shipping_city || selectedOrder.billing_city || "",
      pickup_state: selectedOrder.shipping_state || selectedOrder.billing_state || "",
      pickup_country: selectedOrder.shipping_country || "India",
      pickup_pincode: selectedOrder.shipping_pincode || selectedOrder.billing_pincode || "",
      pickup_email: selectedOrder.shipping_email || selectedOrder.billing_email || "",
      pickup_phone: pickupPhone,

      order_items: selectedItemsForExchange.map(item => ({
        name: item.name,
        sku: item.sku,
        units: item.units,
        selling_price: item.selling_price,
        itemTotalPrice: item.itemTotalPrice || item.unitee_total_price || item.UniteeTotalPrice || item.selling_price,
        hsn: item.hsn || '',
        product_category: item.product_category || '',
      })),

      payment_method: selectedOrder.payment_method,
      sub_total: selectedItemsForExchange.reduce((total, item) => {
        const perItemTotal = parseFloat(item.itemTotalPrice || item.unitee_total_price || item.UniteeTotalPrice || item.selling_price || 0);
        const units = parseInt(item.units) || 1;
        return total + (perItemTotal * units);
      }, 0),

      length: selectedOrder.length || 24,
      breadth: selectedOrder.breadth || 19,
      height: selectedOrder.height || 3,
      weight: selectedOrder.weight || 0.5,

      original_order_id: selectedOrder.id,
      shopDomain: selectedOrder.shopDomain,

      return_reason_id: "6",
      customer_request: "EXCHANGE",
      reason_comment: "Size exchange requested",
    };

    console.log('Size Exchange - Return Order Payload:', returnData);

    // Call create shipmozo return order API
    const returnResponse = await fetch('https://ufb-1.onrender.com/shipmozo/create-shipmozo-return-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(returnData)
    });

    if (!returnResponse.ok) {
      throw new Error('Failed to create return order');
    }

    const returnResult = await returnResponse.json();

    // Generate IDs for the new order
    const excUniteeId = `EXC_${selectedOrder.id}`;
    const generatedOrderId = `${Date.now() % 1000000000}${Math.floor(Math.random() * 100)}`;

    // Compute shipping for the exchange order (match CreateOrderPage style)
    const computeShippingForExchange = () => {
      const b = computeSizeExchangeBreakdown(selectedItemsForExchange, selectedOrder, exchangeShippingPreference || selectedOrder?.shippingPreference);
      // We also need to expose pre-GST parts
      const specialStates = [
        "North East", "J & K", "Ladakh", "Andaman & Nicobar", "Himachal Pradesh",
        "Sikkim", "Lakshadweep", "Arunachal Pradesh", "Assam", "Manipur",
        "Meghalaya", "Mizoram", "Nagaland", "Tripura"
      ];
      const pref = (exchangeShippingPreference || selectedOrder?.shippingPreference);
      const state = selectedOrder?.shipping_state || selectedOrder?.billing_state;
      let baseRate = 0;
      if (pref === 'Air') baseRate = 75; else if (pref === 'Surface') baseRate = 65; else baseRate = specialStates.includes(state) ? 85 : 65;
      const orderBaseShippingCharge = parseFloat(selectedOrder?.baseShippingCharge || 0) || 0;
      const orderTotalUnits = (selectedOrder?.order_items || []).reduce((sum, it) => sum + (parseInt(it.units) || 0), 0) || 1;
      const selectedUnits = selectedItemsForExchange.reduce((sum, it) => sum + (parseInt(it.units) || 0), 0) || 0;
      const shareRatio = Math.min(1, Math.max(0, orderTotalUnits > 0 ? (selectedUnits / orderTotalUnits) : 0));
      const totalSlabs = orderBaseShippingCharge && baseRate ? Math.max(1, Math.round(orderBaseShippingCharge / baseRate)) : Math.max(1, orderTotalUnits);
      const selectedSlabs = Math.max(1, Math.ceil(totalSlabs * shareRatio));
      let baseShippingCharge = baseRate * selectedSlabs;
      const paymentMethodLower = (selectedOrder?.payment_method || '').toLowerCase();
      const isCODorPartial = paymentMethodLower === 'cod' || paymentMethodLower === 'partially paid' || paymentMethodLower === 'partially_paid';
      const selectedItemsSellingSubtotal = selectedItemsForExchange.reduce((sum, item) => sum + ((parseFloat(item.selling_price) || 0) * (parseInt(item.units) || 1)), 0);
      let codShippingCharge = 0;
      if (isCODorPartial) {
        codShippingCharge = selectedItemsSellingSubtotal > 2000 ? (selectedItemsSellingSubtotal * 0.025) : 50;
      }
      const totalShippingCharge = baseShippingCharge + codShippingCharge;
      const shippingTax = totalShippingCharge * 0.18;
      const totalShipping = totalShippingCharge + shippingTax;
      return { baseShippingCharge, codShippingCharge, totalShippingCharge, shippingTax, totalShipping };
    };

    const shippingComputed = computeShippingForExchange();

    console.log(selectedItemsForExchange)
    console.log('📦 Building productsPayload for selectedItemsForExchange:', selectedItemsForExchange);

    // Build products array expected by create order API
    const productsPayload = selectedItemsForExchange.map(item => {
      const design = item.design || {};
      const quantity = parseInt(item.units) || 1;
      const sellingPrice = parseFloat(item.selling_price) || 0;
      const designTotalPrice = getDesignTotalPrice(item);
      const neckLabelPrice = neckLabelsEnabled ? 5 : 0; // 5 Rs per unit if neck labels are enabled
      const itemTotalPrice = designTotalPrice + neckLabelPrice;
      console.log('📦 Item payload - designTotalPrice:', designTotalPrice, 'neckLabelPrice:', neckLabelPrice, 'itemTotalPrice:', itemTotalPrice);
    
      return {
        designName: design.designName || "N/A",
        productName:
          design.productName ||
          (design.colorVariants?.[0]?.productName) ||
          item.product_name ||
          "Unknown Product",
        sellingPrice: sellingPrice * quantity,
        quantity: quantity,
        SKU: item.sku || "N/A",
        selectedSize: item.new_size || "N/A",
        designTotalPrice: designTotalPrice,
        neckLabelPrice: neckLabelPrice,
        itemTotalPrice: itemTotalPrice,
        design: design,
      };
    });
    

       // Calculate subtotal using designTotalPrice + neck label price (what we charge the brand)
    const neckLabelPrice = neckLabelsEnabled ? 5 : 0;
    const subTotalSel = productsPayload.reduce((sum, p) => {
      const designTotalPrice = parseFloat(p.designTotalPrice || 0);
      const neckLabelTotal = neckLabelPrice * p.quantity;
      return sum + designTotalPrice + neckLabelTotal;
    }, 0);
    const totalPriceSel = subTotalSel; // keeping parity with create order page structure

    // Assemble final payload matching CreateOrderPage
    const newOrderData = {
      order_id: generatedOrderId,
     unitee_order_id: excUniteeId,
        user_uid: user.uid,
        order_date: new Date().toISOString().split('T')[0],
        
        // Customer information
        customer_name: selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name,
        last_name: selectedOrder.shipping_last_name || selectedOrder.billing_last_name,
        email: selectedOrder.shipping_email || selectedOrder.billing_email,
        phone: selectedOrder.shipping_phone || selectedOrder.billing_phone,
        
        // Shipping address
        shipping_address: selectedOrder.shipping_address || selectedOrder.billing_address,
        shipping_address_2: selectedOrder.shipping_address_2 || selectedOrder.billing_address_2,
        shipping_city: selectedOrder.shipping_city || selectedOrder.billing_city,
        shipping_state: selectedOrder.shipping_state || selectedOrder.billing_state,
        shipping_country: selectedOrder.shipping_country || "India",
        shipping_pincode: selectedOrder.shipping_pincode || selectedOrder.billing_pincode,
        
        // Billing address (same as shipping for exchange)
        billing_customer_name: selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name,
        billing_last_name: selectedOrder.shipping_last_name || selectedOrder.billing_last_name,
        billing_address: selectedOrder.shipping_address || selectedOrder.billing_address,
        billing_address_2: selectedOrder.shipping_address_2 || selectedOrder.billing_address_2,
        billing_city: selectedOrder.shipping_city || selectedOrder.billing_city,
        billing_state: selectedOrder.shipping_state || selectedOrder.billing_state,
        billing_country: selectedOrder.shipping_country || "India",
        billing_pincode: selectedOrder.shipping_pincode || selectedOrder.billing_pincode,
        billing_email: selectedOrder.shipping_email || selectedOrder.billing_email,
        billing_phone: selectedOrder.shipping_phone || selectedOrder.billing_phone,
        
        // Order details
      products: productsPayload,
      sub_total: subTotalSel,
             total_price: totalPriceSel,
        payment_method: selectedOrder.payment_method,
        shippingPreference: exchangeShippingMethod || selectedOrder.shippingPreference || 'Surface',
        
        // Package details (using calculated volumetric data)
      length: selectedOrder.length || 24,
      breadth: selectedOrder.breadth || 19,
      height: selectedOrder.height || 3,
      weight: selectedOrder.weight || 0.5,
      isPaid: true,
      timestamp: Timestamp.now(),
      shippingCost: shippingComputed.totalShipping,
      shippingLabel: '',
      salesInvoiceUrl: selectedOrder.SalesinvoiceUrl || '',
      is_exchange: true,
      original_order_id: selectedOrder.id || '',
      exchange_reason: 'Size exchange',
    };
    

    console.log('Size Exchange - New Order Payload:', newOrderData);

    // Create new sample shipmozo order
    const newOrderResponse = await fetch('https://ufb-1.onrender.com/create-sample-shipmozo-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(newOrderData)
    });

    if (!newOrderResponse.ok) {
      throw new Error('Failed to create exchange order');
    }

    const newOrderResult = await newOrderResponse.json();

    // Deduct wallet balance and record transaction
    const newBalance = parseFloat((walletBalance - sizeExchangeAmount).toFixed(2));
    const walletRef = firestoreDoc(db, 'users', user.uid, 'wallet', 'walletDetails');
    await updateDoc(walletRef, { balance: newBalance });
    const transactionsRef = collection(walletRef, 'transactions');
    const transactionData = {
      type: `SizeExchange_${selectedOrder.id}`,
      amount: parseFloat(sizeExchangeAmount.toFixed(2)),
      balanceBefore: parseFloat(walletBalance.toFixed(2)),
      balanceAfter: newBalance,
      breakdown: sizeExchangeBreakdown,
      timestamp: Timestamp.now(),
    };
    await addDoc(transactionsRef, transactionData);
    setWalletBalance(newBalance);

    toast.success("Size exchange order created successfully!");
    setShowSizeExchangeModal(false);
    setShowSizeExchangeConfirmModal(false);
    
    // Refresh order details if needed
    fetchOrderDetails(selectedOrder.id);

  } catch (error) {
    console.error("Error creating size exchange:", error);
    toast.error(`Failed to create size exchange: ${error.message}`);
    setShowSizeExchangeConfirmModal(false);
    } finally {
      setSizeExchangeLoading(false);
    }
  };

  // Handle product exchange process
  const handleProductExchange = async () => {
    if (!selectedOrder || selectedExchangeProducts.length === 0) {
      toast.error("Please select products for exchange");
      return;
    }

    setProductExchangeLoading(true);
    try {
      const token = await user.getIdToken();
      
      // First, create return order for refund
      const returnData = {
        user_uid: user.uid,
        id: `R_${selectedOrder.id}_${Date.now()}`,
        order_date: new Date().toISOString().split('T')[0],
        
        // Pickup information (customer's shipping address)
        pickup_customer_name: selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name,
        pickup_last_name: selectedOrder.shipping_last_name || selectedOrder.billing_last_name,
        pickup_address: selectedOrder.shipping_address || selectedOrder.billing_address,
        pickup_address_2: selectedOrder.shipping_address_2 || selectedOrder.billing_address_2,
        pickup_city: selectedOrder.shipping_city || selectedOrder.billing_city,
        pickup_state: selectedOrder.shipping_state || selectedOrder.billing_state,
        pickup_country: selectedOrder.shipping_country || "India",
        pickup_pincode: selectedOrder.shipping_pincode || selectedOrder.billing_pincode,
        pickup_email: selectedOrder.shipping_email || selectedOrder.billing_email,
        pickup_phone: selectedOrder.shipping_phone || selectedOrder.billing_phone,
        
        // Order items - only the selected ones for return
        order_items: productExchangeFormData.selected_items
          .filter((item) => item.selected && item.return_quantity > 0)
          .map((item) => ({
            name: item.name,
            sku: item.sku,
            units: item.return_quantity,
            selling_price: item.selling_price,
          })),
        
        payment_method: selectedOrder.payment_method,
        sub_total: productExchangeFormData.selected_items
          .filter((item) => item.selected && item.return_quantity > 0)
          .reduce(
            (total, item) =>
              total + parseFloat(item.selling_price) * item.return_quantity,
            0
          ),
        
        // Default package dimensions
        length: selectedOrder.length || 24,
        breadth: selectedOrder.breadth || 19,
        height: selectedOrder.height || 3,
        weight: selectedOrder.weight || 0.5,
        
        // Original order reference
        original_order_id: selectedOrder.id,
        shopDomain: selectedOrder.shopDomain,
        
        return_reason_id: "6",
        customer_request: "EXCHANGE",
        reason_comment: "Product exchange requested",
      };



      // Create return order
      const returnResponse = await fetch('https://ufb-1.onrender.com/shipmozo/create-shipmozo-return-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(returnData)
      });

      if (!returnResponse.ok) {
     throw new Error('Failed to create return order');
      }

      const returnResult = await returnResponse.json();

      // Generate IDs for the new order
      const excUniteeId = `EXC_${selectedOrder.id}_${Date.now().toString().slice(-6)}`;
      const generatedOrderId = `${Date.now() % 1000000000}${Math.floor(Math.random() * 100)}`;

      // Compute shipping for the exchange order using proper slab calculation
      const computeShippingForExchange = () => {
        const specialStates = [
          "North East", "J & K", "Ladakh", "Andaman & Nicobar", "Himachal Pradesh",
          "Sikkim", "Lakshadweep", "Arunachal Pradesh", "Assam", "Manipur",
          "Meghalaya", "Mizoram", "Nagaland", "Tripura"
        ];
        const billingState = selectedOrder?.shipping_state || selectedOrder?.billing_state;
        const effectiveShippingPref = exchangeShippingMethod || selectedOrder?.shippingPreference || 'Surface';
        let baseRate = 0;
        if (effectiveShippingPref === "Air") baseRate = 75;
        else if (effectiveShippingPref === "Surface") baseRate = 65;
        else baseRate = specialStates.includes(billingState) ? 85 : 65;

        // Use EXACT same shipping calculation as CreateOrder
        const itemWeight = 0.25; // Base weight for calculating shipping cost (same as CreateOrder)
        
        // Calculate the total weight of products selected (EXACT same as CreateOrder)
        let totalWeight = 0;
        for (const product of selectedExchangeProducts) {
          if (product.quantity && typeof product.quantity === "number") {
            const productWeight = product.quantity * itemWeight;
            totalWeight += productWeight;
          }
        }
        
        const weightGroups = Math.ceil(totalWeight / 0.5); // Group by 0.5 kg (EXACT same as CreateOrder)
        const baseShippingCharge = baseRate * weightGroups;

        // No COD shipping for exchanges - all are prepaid
        const totalShippingCharge = baseShippingCharge;
        const shippingTax = totalShippingCharge * 0.18;
        const totalShipping = totalShippingCharge + shippingTax;
        return { baseShippingCharge, codShippingCharge: 0, totalShippingCharge, shippingTax, totalShipping };
      };

      const shippingComputed = computeShippingForExchange();
      
      // Calculate volumetric data for package details
      const volumetricData = calculateVolumetricWeight(selectedExchangeProducts);

      // Build products array for new order
      const productsPayload = selectedExchangeProducts.map(item => {
        const design = item.design || {};
        const quantity = item.quantity || 1;
        const sellingPrice = parseFloat(item.sellingPrice || item.totalPrice) || 0;
       const designTotalPrice = getDesignTotalPrice(item);
        const neckLabelPrice = neckLabelsEnabled ? 5 : 0; // 5 Rs per unit if neck labels are enabled
        const itemTotalPrice = designTotalPrice + neckLabelPrice;
        console.log('📦 Item payload (exchange) - designTotalPrice:', designTotalPrice, 'neckLabelPrice:', neckLabelPrice, 'itemTotalPrice:', itemTotalPrice);
      
        return {
          designName: design.designName || "N/A",
          productName: design.productName || (design.colorVariants?.[0]?.productName) || item.product_name || "Unknown Product",
          sellingPrice: sellingPrice * quantity,
          quantity: quantity,
          SKU: item.sku || item.selectedSKU || "N/A",
          selectedSize: item.selectedSize || "N/A",
          designTotalPrice: designTotalPrice,
          neckLabelPrice: neckLabelPrice,
          itemTotalPrice: itemTotalPrice,
          design: design,
        };
      });
      
      // Calculate subtotal using designTotalPrice + neck label price (what we charge the brand)
      const neckLabelPrice = neckLabelsEnabled ? 5 : 0;
      const subTotalSel = productsPayload.reduce((sum, p) => {
        const designTotalPrice = parseFloat(p.designTotalPrice || 0);
        const neckLabelTotal = neckLabelPrice * p.quantity;
        return sum + designTotalPrice + neckLabelTotal;
      }, 0);
      const totalPriceSel = subTotalSel;

   // Assemble final payload for new order
      const newOrderData = {
        order_id: generatedOrderId,
      unitee_order_id: excUniteeId,
        user_uid: user.uid,
        order_date: new Date().toISOString().split('T')[0],
        
        // Customer information
        customer_name: selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name,
        last_name: selectedOrder.shipping_last_name || selectedOrder.billing_last_name,
        email: selectedOrder.shipping_email || selectedOrder.billing_email,
        phone: selectedOrder.shipping_phone || selectedOrder.billing_phone,
        
        // Shipping address
        shipping_address: selectedOrder.shipping_address || selectedOrder.billing_address,
        shipping_address_2: selectedOrder.shipping_address_2 || selectedOrder.billing_address_2,
        shipping_city: selectedOrder.shipping_city || selectedOrder.billing_city,
        shipping_state: selectedOrder.shipping_state || selectedOrder.billing_state,
        shipping_country: selectedOrder.shipping_country || "India",
        shipping_pincode: selectedOrder.shipping_pincode || selectedOrder.billing_pincode,
        
        // Billing address (same as shipping for exchange)
        billing_customer_name: selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name,
        billing_last_name: selectedOrder.shipping_last_name || selectedOrder.billing_last_name,
        billing_address: selectedOrder.shipping_address || selectedOrder.billing_address,
        billing_address_2: selectedOrder.shipping_address_2 || selectedOrder.billing_address_2,
        billing_city: selectedOrder.shipping_city || selectedOrder.billing_city,
        billing_state: selectedOrder.shipping_state || selectedOrder.billing_state,
        billing_country: selectedOrder.shipping_country || "India",
        billing_pincode: selectedOrder.shipping_pincode || selectedOrder.billing_pincode,
        billing_email: selectedOrder.shipping_email || selectedOrder.billing_email,
        billing_phone: selectedOrder.shipping_phone || selectedOrder.billing_phone,
        
        // Order details
        products: productsPayload,
        sub_total: subTotalSel,
              total_price: totalPriceSel,
        payment_method: selectedOrder.payment_method,
        shippingPreference: exchangeShippingMethod || selectedOrder.shippingPreference || 'Surface',
        
        // Package details (using calculated volumetric data)
        length: volumetricData.length,
        breadth: volumetricData.breadth,
        height: volumetricData.height,
        weight: volumetricData.weight,
       
        // Shipping costs
        baseShippingCharge: shippingComputed.baseShippingCharge,
        codShippingCharge: shippingComputed.codShippingCharge,
        totalShippingCharge: shippingComputed.totalShippingCharge,
        shippingTax: shippingComputed.shippingTax,
        totalShipping: shippingComputed.totalShipping,
        
        // Exchange reference
        original_order_id: selectedOrder.id,
        shopDomain: selectedOrder.shopDomain,
        isExchange: true,
        exchangeType: "PRODUCT_EXCHANGE",
      };

      // Create new order
      const newOrderResponse = await fetch('https://ufb-1.onrender.com/create-sample-shipmozo-order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(newOrderData)
      });

      if (!newOrderResponse.ok) {
       throw new Error('Failed to create new order');
      }

      const newOrderResult = await newOrderResponse.json();

      // Calculate total cost for wallet deduction
      const totalCost = (totalPriceSel + shippingComputed.totalShipping) * 1.05; // 5% tax
      const newBalance = parseFloat((walletBalance - totalCost).toFixed(2));
      
      // Update wallet balance
      const walletRef = firestoreDoc(db, 'users', user.uid, 'wallet', 'walletDetails');
      await updateDoc(walletRef, { balance: newBalance });

      // Record transaction
      const transactionsRef = collection(walletRef, 'transactions');
      const transactionData = {
        type: `Product_Exchange_${selectedOrder.id}`,
        amount: totalCost,
        balanceBefore: walletBalance,
        balanceAfter: newBalance,
        timestamp: Timestamp.now(),
      };
      await addDoc(transactionsRef, transactionData);

      toast.success("Product exchange processed successfully!");
      setShowProductExchangeModal(false);
      setShowProductExchangeConfirmModal(false);
      
      // Refresh orders
      fetchOrdersFromApi(activeTab, true);

    } catch (error) {
      console.error('Error processing product exchange:', error);
      toast.error(`Error processing product exchange: ${error.message}`);
    } finally {
      setProductExchangeLoading(false);
    }
  };



// Add this function to fetch wallet balance (call this in useEffect or when component mounts)
const fetchWalletBalance = async () => {
  try {
    const token = await user.getIdToken();
    const walletRef = firestoreDoc(db, 'users', user.uid, 'wallet', 'walletDetails');
    const walletDoc = await getDoc(walletRef);
    
    if (walletDoc.exists()) {
      setWalletBalance(walletDoc.data().balance || 0);
    }
  } catch (error) {
    console.error("Error fetching wallet balance:", error);
    setWalletBalance(0);
  }
};


  // Helper function to check if order is delivered
  const isOrderDelivered = (order) => {
    return order?.tracking_status?.toLowerCase() === "delivered";
  };

  // NEW: Function to open the return modal and pre-fill data
  const openReturnModal = (order) => {
    setReturnFormData({
      ...returnFormData,
      pickup_customer_name: order.shipping_customer_name || "",
      pickup_phone: order.shipping_phone || "",
      pickup_email: order.shipping_email || "",
      pickup_address: order.shipping_address || "",
      pickup_address_2: order.shipping_address_2 || "",
      pickup_pincode: order.shipping_pincode || "",
      pickup_city: order.shipping_city || "",
      pickup_state: order.shipping_state || "",
      // Initialize with all items selected with original quantities
      selected_items: (order.order_items || []).map((item) => ({
        ...item,
        return_quantity: item.units, // Default to full quantity
        selected: true, // Default to selected
      })),
    });
    setShowReturnModal(true);
  };
  // NEW: Function to close the return modal
  const closeReturnModal = () => {
    setShowReturnModal(false);
  };



  // NEW: Function to open the size exchange modal
  const openSizeExchangeModal = (order) => {
    // Ensure no other modals are visible
    setShowReturnModal(false);
    setShowConfirmModal(false);
    setShowSizeExchangeConfirmModal(false);
    setSizeExchangeFormData({
      selected_items: (order.order_items || []).map((item) => ({
        ...item,
        selected: true,
        new_size: item.size || item.variant_size || '', // Default to current size
        available_sizes: [], // Will be populated from API
      })),
    });
    // Preselect shipping preference
    setExchangeShippingPreference(order?.shippingPreference || 'Surface');
    setShowSizeExchangeModal(true);
  };

  // NEW: Function to close the size exchange modal
  const closeSizeExchangeModal = () => {
    setShowSizeExchangeModal(false);
  };

  // Product Exchange functions
  const openProductExchangeModal = (order) => {
    // Ensure no other modals are visible
    setShowReturnModal(false);
    setShowConfirmModal(false);
    setShowSizeExchangeModal(false);
    setShowSizeExchangeConfirmModal(false);
    setProductExchangeFormData({
      selected_items: (order.order_items || []).map((item) => ({
        ...item,
        selected: true,
        return_quantity: item.units || 1,
      })),
      exchange_products: [],
    });
    setSelectedExchangeProducts([]);
    setShowProductExchangeModal(true);
  };

  const closeProductExchangeModal = () => {
    setShowProductExchangeModal(false);
    setIsProductModalOpen(false); // Also close product selection modal if open
  };

  const handleProductExchangeItemSelection = (itemIndex, isSelected) => {
    setProductExchangeFormData((prev) => ({
      ...prev,
      selected_items: prev.selected_items.map((item, index) =>
        index === itemIndex
          ? {
              ...item,
              selected: isSelected,
              return_quantity: isSelected ? item.units : 0,
            }
          : item
      ),
    }));
  };

  const handleExchangeProductQuantityChange = (productIndex, newQuantity) => {
    setSelectedExchangeProducts((prev) =>
      prev.map((product, index) =>
        index === productIndex
          ? { ...product, quantity: Math.max(1, parseInt(newQuantity) || 1) }
          : product
      )
    );
  };

  const fetchProducts = async () => {
    setProductsLoading(true);
    try {
      const productsCollection = collection(db, 'users', user.uid, 'designs');
      const productsSnapshot = await getDocs(productsCollection);
      const productList = productsSnapshot.docs.map((firestoreDoc) => ({
        id: firestoreDoc.id,
        ...firestoreDoc.data(),
      }));
      setExchangeProducts(productList);
    } catch (error) {
      console.error('Error fetching products:', error);
      toast.error('Failed to fetch products');
    } finally {
      setProductsLoading(false);
    }
  };

  const handleAddExchangeProduct = () => {
    if (exchangeProducts.length === 0) {
      fetchProducts();
    }
    setIsProductModalOpen(true);
  };

  const handleSelectExchangeProduct = (product) => {
    // Handle both single product and array of products from ProductSelectionModal
    const productsToAdd = Array.isArray(product) ? product : [product];
    
    productsToAdd.forEach((prod) => {
      const existingProduct = selectedExchangeProducts.find(
        (p) => p.id === prod.id && p.selectedSize === prod.selectedSize
      );

      if (existingProduct) {
        setSelectedExchangeProducts((prev) =>
          prev.map((p) =>
            p.id === prod.id && p.selectedSize === prod.selectedSize
              ? { ...p, quantity: p.quantity + 1 }
              : p
          )
        );
      } else {
        setSelectedExchangeProducts((prev) => [
          ...prev,
          {
            ...prod,
            quantity: 1,
            selectedSKU: prod.selectedSKU,
          },
        ]);
      }
    });
    
    setIsProductModalOpen(false);
    toast.success(`Added ${productsToAdd.length} product(s) to exchange list!`);
  };

  const removeExchangeProduct = (productIndex) => {
    setSelectedExchangeProducts((prev) =>
      prev.filter((_, index) => index !== productIndex)
    );
  };

  // Calculate volumetric weight and slabs (EXACT same as CreateOrder)
  function calculateVolumetricWeight(selectedProducts) {
    const baseDimensions = { L: 24, B: 19, H: 3 }; // Base dimensions for the first 2 items
    const stepIncrease = { L: 4, B: 4, H: 1 }; // Dimensions increase per additional 2 products
    
    const weightPerTShirt = 0.25; // Since 2 T-shirts make 1 slab of 0.5kg
    const weightPerBabyTee = 0.167; // Since 3 Baby Tees make 1 slab of 0.5kg
    
    let totalWeight = 0;
    let totalSlabs = 0;
    
    let maxLength = baseDimensions.L;
    let maxBreadth = baseDimensions.B;
    let maxHeight = baseDimensions.H;

    selectedProducts.forEach(product => {
        const quantity = product.quantity;
        const name = (product.productName || product.designName || '').toLowerCase();

        if (quantity && typeof quantity === "number" && quantity > 0) {
            let productWeight = 0;
            let slabs = 0;

            if (name.includes("t-shirt")) {
                productWeight = quantity * weightPerTShirt; // Calculate exact weight
                slabs = Math.ceil(quantity / 2); // Slabs are still based on grouping
            } else if (name.includes("baby tee")) {
                productWeight = quantity * weightPerBabyTee; // Calculate exact weight
                slabs = Math.ceil(quantity / 3);
            } else {
                slabs = Math.ceil(quantity / 2); // Default slab calculation for other products
                productWeight = slabs * 0.5; // Assuming default products follow the old slab rule
            }

            totalWeight += productWeight;
            totalSlabs = Math.max(totalSlabs, slabs); // Get max slabs for dimension calculation (EXACT same as CreateOrder)
        }
    });

    // Adjust dimensions based on the maximum slabs required
    maxLength = baseDimensions.L + (totalSlabs - 1) * stepIncrease.L;
    maxBreadth = baseDimensions.B + (totalSlabs - 1) * stepIncrease.B;
    maxHeight = baseDimensions.H + (totalSlabs - 1) * stepIncrease.H;

    return {
        length: maxLength,
        breadth: maxBreadth,
        height: maxHeight,
        weight: parseFloat(totalWeight.toFixed(3)), // Ensure the weight is rounded properly
        slabs: totalSlabs
    };
  }

  // Calculate exchange cost breakdown
  const calculateExchangeCostBreakdown = () => {
    if (!selectedOrder || selectedExchangeProducts.length === 0) {
      return {
        itemsSubtotal: 0,
        tax5: 0,
        baseShipping: 0,
        codShipping: 0,
        shippingTax: 0,
        totalShipping: 0,
        totalCost: 0
      };
    }

    // Calculate items subtotal
// Calculate items subtotal and neck label total separately
    console.log('💰 calculateExchangeCostBreakdown - selectedExchangeProducts:', selectedExchangeProducts);
    let itemsSubtotal = 0;
    let neckLabelTotal = 0;
    
    selectedExchangeProducts.forEach(item => {
      console.log('💰 Processing item for cost breakdown:', item);
      const designTotalPrice = getDesignTotalPrice(item);
      const neckLabelPrice = neckLabelsEnabled ? 5 : 0; // 5 Rs per unit if neck labels are enabled
      const quantity = item.quantity || 1;
      itemsSubtotal += designTotalPrice * quantity;
      neckLabelTotal += neckLabelPrice * quantity;
      
      console.log('💰 Item calculation - designTotalPrice:', designTotalPrice, 'neckLabelPrice:', neckLabelPrice, 'quantity:', quantity);
    });
    
    console.log('💰 Total itemsSubtotal (without neck labels):', itemsSubtotal);
    console.log('💰 Total neckLabelTotal:', neckLabelTotal);

     // Calculate 5% tax on items + neck labels
    const taxableAmount = itemsSubtotal + neckLabelTotal;
    const tax5 = parseFloat((taxableAmount * 0.05).toFixed(2));

    // Calculate shipping using proper slab calculation (same as CreateOrder)
    const specialStates = [
      "North East", "J & K", "Ladakh", "Andaman & Nicobar", "Himachal Pradesh",
      "Sikkim", "Lakshadweep", "Arunachal Pradesh", "Assam", "Manipur",
      "Meghalaya", "Mizoram", "Nagaland", "Tripura"
    ];
    const billingState = selectedOrder?.shipping_state || selectedOrder?.billing_state;
    let baseRate = 0;
    if (exchangeShippingMethod === "Air") baseRate = 75;
    else if (exchangeShippingMethod === "Surface") baseRate = 65;
    else baseRate = specialStates.includes(billingState) ? 75 : 65;

    // Use EXACT same shipping calculation as CreateOrder
    const itemWeight = 0.25; // Base weight for calculating shipping cost (same as CreateOrder)
    
    // Calculate the total weight of products selected (EXACT same as CreateOrder)
    let totalWeight = 0;
    for (const product of selectedExchangeProducts) {
      if (product.quantity && typeof product.quantity === "number") {
        const productWeight = product.quantity * itemWeight;
        totalWeight += productWeight;
      }
    }
    
    const weightGroups = Math.ceil(totalWeight / 0.5); // Group by 0.5 kg (EXACT same as CreateOrder)
    const baseShipping = baseRate * weightGroups;

    // No COD shipping for exchanges - all are prepaid
    const totalShippingCharge = baseShipping;
    const shippingTax = parseFloat((totalShippingCharge * 0.18).toFixed(2));
    const totalShipping = parseFloat((totalShippingCharge + shippingTax).toFixed(2));

   const totalCost = parseFloat((itemsSubtotal + neckLabelTotal + tax5 + totalShipping).toFixed(2));

    return {
      itemsSubtotal: parseFloat(itemsSubtotal.toFixed(2)),
      neckLabelTotal: parseFloat(neckLabelTotal.toFixed(2)),
      tax5,
      baseShipping: parseFloat(baseShipping.toFixed(2)),
      codShipping: 0, // No COD for exchanges
      shippingTax,
      totalShipping,
      totalCost
    };
  };

  // NEW: Function to handle changes in the return form
  const handleReturnFormChange = (field, value) => {
    setReturnFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };



  // Handle item selection toggle
  const handleItemSelection = (itemIndex, isSelected) => {
    setReturnFormData((prev) => ({
      ...prev,
      selected_items: prev.selected_items.map((item, index) =>
        index === itemIndex
          ? {
              ...item,
              selected: isSelected,
              return_quantity: isSelected ? item.units : 0,
            }
          : item
      ),
    }));
  };



  const handleSizeExchangeItemSelection = (itemIndex, isSelected) => {
    setSizeExchangeFormData((prev) => ({
      ...prev,
      selected_items: prev.selected_items.map((item, index) =>
        index === itemIndex
          ? {
              ...item,
              selected: isSelected,
            }
          : item
      ),
    }));
  };

  // Handle size change in size exchange
  const handleSizeChange = (itemIndex, newSize) => {
    setSizeExchangeFormData((prev) => ({
      ...prev,
      selected_items: prev.selected_items.map((item, index) =>
        index === itemIndex
          ? {
              ...item,
              new_size: newSize,
            }
          : item
      ),
    }));
  };

  // Handle quantity change
  const handleQuantityChange = (itemIndex, newQuantity) => {
    setReturnFormData((prev) => ({
      ...prev,
      selected_items: prev.selected_items.map((item, index) =>
        index === itemIndex
          ? {
              ...item,
              return_quantity: Math.min(
                Math.max(0, parseInt(newQuantity) || 0),
                item.units
              ),
              selected: (parseInt(newQuantity) || 0) > 0,
            }
          : item
      ),
    }));
  };

// Update your existing handleLoadMore function
const handleLoadMore = () => {
  if (hasMore && !loadingMore) {
    if (activeTab === "returns") {
      if (returnOrdersHasMore) {
        fetchReturnOrdersFromApi(false);
      }
    } else if (activeTab !== "return-inventory") {
      fetchOrdersFromApi(activeTab, false);
    }
  }
};

  function formatPrintMethod(printMethod) {
    if (!printMethod || typeof printMethod !== "object") return "N/A";
    return Object.entries(printMethod)
      .filter(([_, method]) => method)
      .map(([area, method]) => `${capitalize(area)}: ${method}`)
      .join(", ");
  }

  function capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

 // Function to fetch return inventory
  const fetchRtoInventory = async () => {
    setRtoLoading(true);
    try {
      const token = await user.getIdToken();
      const res = await fetch(
        `https://ufb-1.onrender.com/api/rto-inventory/${user.uid}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

       if (!res.ok) throw new Error("Failed to fetch return inventory");  

      const data = await res.json();
      console.log(data);

      if (data.success && data.inventory) {
        // Convert inventory object to array and filter items with non-zero counts
        const inventoryArray = Object.keys(data.inventory)
          .map((sku) => ({
            sku,
            brandId: data.inventory[sku].brandId,
            counts: data.inventory[sku].counts || {},
            frontImage: data.inventory[sku].frontImage,
            backImage: data.inventory[sku].backImage,
            designName: data.inventory[sku].designName || null, // ✅ Include designName
          }))
          .filter((item) => {
            // Only include items that have at least one size with count > 0
            return Object.entries(item.counts).some(
              ([size, count]) => size !== "designName" && count > 0
            );
          });

        setRtoInventory(inventoryArray);
      } else {
        setRtoInventory([]);
      }
    } catch (error) {
      console.error("Error fetching return inventory:", error);
      setError(`Error fetching return inventory: ${error.message}`);
      setRtoInventory([]);
    } finally {
      setRtoLoading(false);
    }
  };


const fetchReturnLogs = async (isInitialLoad = true) => {
  if (isInitialLoad) {
    setReturnLogsLoading(true);
    setReturnLogs([]);
    setReturnLogsOldestDate(null);
  } else {
    setReturnLogsLoadingMore(true);
  }

  try {
    const token = await user.getIdToken();
    const url = new URL(`https://ufb-1.onrender.com/api/rto-inventory/users/${user.uid}/return-logs`);
    url.searchParams.set("limit", "20");
    
    // For loading more, pass the oldest date from previous batch
    if (!isInitialLoad && returnLogsOldestDate) {
      url.searchParams.set("startDate", returnLogsOldestDate);
    }
    
    const res = await fetch(url, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) throw new Error("Failed to fetch return logs");

    const data = await res.json();
    const fetchedLogs = data.logs || [];
    
    if (isInitialLoad) {
      setReturnLogs(fetchedLogs);
    } else {
      setReturnLogs(prev => [...prev, ...fetchedLogs]);
    }
    
    setReturnLogsHasMore(data.hasMore || false);
    setReturnLogsOldestDate(data.oldestDate);
    
    console.log(`Fetched ${fetchedLogs.length} logs, hasMore: ${data.hasMore}`);
  } catch (error) {
    console.error("Error fetching return logs:", error);
    setError(`Error fetching return logs: ${error.message}`);
    if (isInitialLoad) {
      setReturnLogs([]);
    }
  } finally {
    setReturnLogsLoading(false);
    setReturnLogsLoadingMore(false);
  }
};

// Add load more handler for return logs
const handleReturnLogsLoadMore = () => {
  if (returnLogsHasMore && !returnLogsLoadingMore) {
    fetchReturnLogs(false);
  }
};



// Update your existing handleTabChange function
const handleTabChange = (tabId) => {
  setActiveTab(tabId);
  setFilteredOrders([]);
  setSearchTerm("");
  
  if (tabId === "return-inventory") {
    fetchRtoInventory();
     fetchReturnLogs(true);
  } else if (tabId === "returns") {
    // Fetch return orders specifically
    fetchReturnOrdersFromApi(true);
  } else {
    // Fetch regular orders specific to this tab
    fetchOrdersFromApi(tabId, true);
  }
};

  // Get orders filtered by active tab
  const getFilteredOrdersByTab = (ordersList) => {
    if (activeTab === "all") return ordersList;

    const currentTab = tabs.find((tab) => tab.id === activeTab);
    if (!currentTab || !currentTab.status) return ordersList;

    return ordersList.filter((order) =>
      currentTab.status.includes(order.tracking_status?.toLowerCase())
    );
  };

  // Update the display logic to use return orders when on returns tab
const getDisplayOrders = () => {
  if (activeTab === "returns") {
    const baseOrders = searchTerm ? filteredOrders : returnOrders;
    return baseOrders.filter((order) => {
      // Payment method filter for return orders
      if (paymentMethodFilter !== "all") {
        const orderPaymentMethod = order.payment_type || order.payment_method;
        if (orderPaymentMethod?.toLowerCase() !== paymentMethodFilter.toLowerCase()) {
          return false;
        }
      }

      // Date filters
      const orderDate = order.order_date ? new Date(order.order_date) : null;
      if (startDate && orderDate && orderDate < new Date(startDate)) {
        return false;
      }
      if (endDate && orderDate && orderDate > new Date(endDate)) {
        return false;
      }

      return true;
    });
  } else if (activeTab === "return-inventory") {
    return []; // RTO inventory doesn't use this
  } else {
    const baseOrders = searchTerm ? filteredOrders : orders;
    return baseOrders.filter((order) => {
      // Payment method filter for regular orders
      if (
        paymentMethodFilter !== "all" &&
        order.payment_method?.toLowerCase() !== paymentMethodFilter.toLowerCase()
      ) {
        return false;
      }

      // Date filters
      const orderDate = order.order_date ? new Date(order.order_date) : null;
      if (startDate && orderDate && orderDate < new Date(startDate)) {
        return false;
      }
      if (endDate && orderDate && orderDate > new Date(endDate)) {
        return false;
      }

      return true;
    });
  }
};

  // Get status badge color
const getStatusColor = (status) => {
  const normalizedStatus = status?.toLowerCase();
  const statusColors = {
    // Regular order statuses
    delivered: "bg-green-100 text-green-800",
    in_transit: "bg-blue-100 text-blue-800",
    out_for_delivery: "bg-orange-100 text-orange-800",
    ndr: "bg-red-100 text-red-800",
    rto_initiated: "bg-purple-100 text-purple-800",
    rto_in_transit: "bg-purple-100 text-purple-800",
    rto_delivered: "bg-purple-100 text-purple-800",
    return_initiated: "bg-yellow-100 text-yellow-800",
    return_delivered: "bg-yellow-100 text-yellow-800",
    canceled: "bg-gray-100 text-gray-800",
    cancelled: "bg-gray-100 text-gray-800",
    pending: "bg-yellow-100 text-yellow-800",
    confirmed: "bg-blue-100 text-blue-800",
    processing: "bg-indigo-100 text-indigo-800",
    ready_to_ship: "bg-cyan-100 text-cyan-800",
    delivery_exception: "bg-red-100 text-red-800",
    pickup_rescheduled: "bg-orange-100 text-orange-800",
    
    // Return order specific statuses
    "pickup completed": "bg-green-100 text-green-800",
    "undelivered": "bg-red-100 text-red-800",
    "return in transit": "bg-blue-100 text-blue-800",
    "return delivered": "bg-green-100 text-green-800",
    "return pickup": "bg-orange-100 text-orange-800",
    "return initiated": "bg-yellow-100 text-yellow-800",
  };
  return statusColors[normalizedStatus] || "bg-gray-100 text-gray-800";
};

// 2. Update the payment method filter to handle return orders
const getPaymentMethodColor = (method) => {
  const methodLower = method?.toLowerCase();
  switch (methodLower) {
    case "prepaid":
      return "bg-green-100 text-green-800";
    case "cod":
      return "bg-yellow-100 text-yellow-800";
    default:
      return "bg-red-100 text-red-800";
  }
};
  // Format date
  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB");
  };

  // Format price
  const formatPrice = (price) => {
    return `₹${price || 0}`;
  };

  // Handle view order details
  const handleViewOrder = (orderId) => {
    console.log("Viewing order:", orderId); // Debug log
    fetchOrderDetails(orderId);
  };

  // Close modal
  const closeModal = () => {
    setShowModal(false);
    setSelectedOrder(null);
  };

useEffect(() => {
  fetchWalletBalance();

  // Fetch orders for the initial "all" tab
  fetchOrdersFromApi("all", true);
  
  // If user directly lands on returns tab, fetch return orders
  if (activeTab === "returns") {
    fetchReturnOrdersFromApi(true);
  }
}, []);

  // Update your useEffect for filters to handle return orders
useEffect(() => {
  if (activeTab === "returns") {
    fetchReturnOrdersFromApi(true);
  } else if (activeTab !== "rto-inventory") {
    fetchOrdersFromApi(activeTab, true);
  }
}, [paymentMethodFilter, startDate, endDate]);

  // RTO Inventory Cards for all screen sizes - Simplified
  const renderRtoInventoryCards = () => (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {rtoInventory.map((item) => (
        <div
          key={item.sku}
          className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-shadow duration-300"
        >
          {/* Images Section */}
          <div className="relative bg-gray-50 p-4">
            <div className="grid grid-cols-2 gap-2 h-32">
              <div className="relative bg-white rounded-lg border-2 border-dashed border-gray-200 overflow-hidden">
                {item.frontImage ? (
                  <img
                    src={item.frontImage}
                    alt="Product Front"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="flex items-center justify-center h-full text-gray-400 text-xs">
                    No Front Image
                  </div>
                )}
              </div>
              <div className="relative bg-white rounded-lg border-2 border-dashed border-gray-200 overflow-hidden">
                {item.backImage ? (
                  <img
                    src={item.backImage}
                    alt="Product Back"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="flex items-center justify-center h-full text-gray-400 text-xs">
                    No Back Image
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="p-4 space-y-3">
            {/* Design Name */}
            <div>
              <p className="text-sm text-gray-600">
                <strong>Design Name:</strong> {item?.designName || "N/A"}
              </p>
            </div>

            {/* SKU */}
            <div>
              <p className="text-sm text-gray-600">
                <strong>SKU:</strong> {item.sku}
              </p>
            </div>

            {/* Available Sizes - Only show sizes with count > 0 */}
            <div>
              <p className="text-sm text-gray-600 mb-2">
                <strong>Available Sizes:</strong>
              </p>
              <div className="space-y-1 ml-4">
                {Object.entries(item.counts)
                  .filter(([size, count]) => size !== "designName" && count > 0)
                  .map(([size, count]) => (
                    <p key={size} className="text-sm text-gray-600">
                      <strong>{size.toUpperCase()}:</strong> {count}
                    </p>
                  ))}
                {Object.entries(item.counts).filter(
                  ([size, count]) => size !== "designName" && count > 0
                ).length === 0 && (
                  <p className="text-sm text-gray-400 italic">
                    No stock available
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );


const renderReturnLogsTable = () => (
  <>
    {/* Desktop Table View */}
    <div className="hidden lg:block bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full table-auto">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Image</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Design Name</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Size</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Qty</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Type</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Additional Notes</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Unitee ID</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Store ID</th>
              <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">Date</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {returnLogs.map((log) => (
              <tr key={`${log.id}-${log.orderType}`} className="hover:bg-gray-50">
                <td className="px-4 py-3">
                  <div className="w-12 h-12 bg-gray-100 rounded-lg overflow-hidden">
                    {log.frontImage ? (
                      <img
                        src={log.frontImage}
                        alt="Product"
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">
                        No Image
                      </div>
                    )}
                  </div>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-900">{log.designName || 'N/A'}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-600">{log.size || 'N/A'}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-600">{log.quantity || 'N/A'}</span>
                </td>
                <td className="px-4 py-3 whitespace-nowrap">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    log.orderType === 'return' 
                      ? 'bg-red-100 text-red-800' 
                      : log.orderType === 'rto'
                      ? 'bg-red-100 text-red-800'
                      : log.orderType === 'return_reshipped'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-green-100 text-green-800'
                  }`}>
                    {log.orderType === 'return' 
                      ? 'Return Received' 
                      : log.orderType === 'rto'
                      ? 'RTO Received'
                      : log.orderType === 'return_reshipped'
                      ? 'Return Reshipped'
                      : 'RTO Reshipped'
                    }
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-600">{log.additionalNotes || 'N/A'}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-900 font-mono">{log.id}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-blue-600">{log.storeOrderId || 'N/A'}</span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-gray-600">{log.receivedDate}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Load More Button for Desktop Table */}
      {returnLogsHasMore && (
        <div className="p-4 text-center border-t border-gray-200">
          <button
            onClick={handleReturnLogsLoadMore}
            disabled={returnLogsLoadingMore}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm"
          >
            {returnLogsLoadingMore ? "Loading..." : "Load More Logs"}
          </button>
        </div>
      )}
    </div>

    {/* Mobile and Tablet Card View */}
    <div className="lg:hidden space-y-4">
      {returnLogs.map((log) => (
        <div key={`${log.id}-${log.orderType}`} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <div className="p-4">
            {/* Header with Image and Basic Info */}
            <div className="flex items-start space-x-4 mb-4">
              <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex-shrink-0">
                {log.frontImage ? (
                  <img
                    src={log.frontImage}
                    alt="Product"
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">
                    No Image
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-gray-900 truncate mb-1">
                  {log.designName || 'N/A'}
                </h3>
                <div className="flex items-center space-x-4 text-sm text-gray-600 mb-2">
                  <span>Size: {log.size || 'N/A'}</span>
                  <span>Qty: {log.quantity || 'N/A'}</span>
                </div>
                <div className="mb-2">
                  <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                    log.orderType === 'return' 
                      ? 'bg-red-100 text-red-800' 
                      : log.orderType === 'rto'
                      ? 'bg-red-100 text-red-800'
                      : log.orderType === 'return_reshipped'
                      ? 'bg-green-100 text-green-800'
                      : 'bg-green-100 text-green-800'
                  }`}>
                    {log.orderType === 'return' 
                      ? 'Return Received' 
                      : log.orderType === 'rto'
                      ? 'RTO Received'
                      : log.orderType === 'return_reshipped'
                      ? 'Return Reshipped'
                      : 'RTO Reshipped'
                    }
                  </span>
                </div>
              </div>
            </div>

            {/* Details Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-3 gap-x-4 pt-3 border-t border-gray-100">
              <div>
                <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider">Date</dt>
                <dd className="mt-1 text-sm text-gray-900">{log.receivedDate}</dd>
              </div>
              
              <div>
                <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider">Unitee ID</dt>
                <dd className="mt-1 text-sm text-gray-900 font-mono break-all">{log.id}</dd>
              </div>
              
              <div>
                <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider">Store ID</dt>
                <dd className="mt-1 text-sm text-blue-600">{log.storeOrderId || 'N/A'}</dd>
              </div>
              
              <div>
                <dt className="text-xs font-medium text-gray-500 uppercase tracking-wider">Additional Notes</dt>
                <dd className="mt-1 text-sm text-gray-600 break-words">{log.additionalNotes || 'N/A'}</dd>
              </div>
            </div>
          </div>
        </div>
      ))}
      
      {/* Load More Button for Mobile Cards */}
      {returnLogsHasMore && (
        <div className="text-center pt-4">
          <button
            onClick={handleReturnLogsLoadMore}
            disabled={returnLogsLoadingMore}
            className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm"
          >
            {returnLogsLoadingMore ? "Loading..." : "Load More Logs"}
          </button>
        </div>
      )}
    </div>
  </>
);

  const baseOrders = searchTerm ? filteredOrders : orders;
  const filteredByPaymentAndDate = baseOrders.filter((order) => {
    // Payment method filter
    if (
      paymentMethodFilter !== "all" &&
      order.payment_method?.toLowerCase() !== paymentMethodFilter.toLowerCase()
    ) {
      return false;
    }

    // Date filters
    const orderDate = order.order_date ? new Date(order.order_date) : null;
    if (startDate && orderDate && orderDate < new Date(startDate)) {
      return false;
    }
    if (endDate && orderDate && orderDate > new Date(endDate)) {
      return false;
    }

    return true;
  });
  const displayOrders = getDisplayOrders();

  // 8. Update loading states for different tabs
const isCurrentTabLoading = () => {
  if (activeTab === "returns") {
    return returnOrdersLoading;
  } else if (activeTab !== "return-inventory") {
    return rtoLoading;
  } else {
    return loading;
  }
};


  // Update the loading condition
if (loading || (activeTab === "returns" && returnOrdersLoading)) {
  return (
    <div className="flex h-screen bg-white overflow-hidden">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <Header />
        <main className="flex-1 flex justify-center items-center p-4">
          <div className="text-base md:text-lg text-gray-600">
            {activeTab === "returns" ? "Loading return orders..." : "Loading orders..."}
          </div>
        </main>
      </div>
    </div>
  );
}

  return (
    <div className="flex h-screen bg-white">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
        <Header />
        <main className="flex-1 p-3 sm:p-4 md:p-6 lg:p-8 overflow-y-auto">
          {/* Header */}
          <div className="mb-6 lg:mb-8">
            <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-800 text-left mx-2 order-management-title uppercase">
              Order Management
            </h1>
          </div>

          {/* Search and Filters Section */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-5 md:p-6 mb-6 lg:mb-8">
            {/* Search Bar */}
            <div className="mb-4 md:mb-6">
              <div className="relative">
                <FaSearch className="absolute left-3 sm:left-4 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
<input
  type="text"
  placeholder={
    activeTab === "returns" 
      ? "Search by Return ID, AWB Code, Pickup Name, or SKU"
      : "Search by Order ID, Unitee ID, or Customer Name"
  }
  value={searchTerm}
  onChange={(e) => handleSearch(e.target.value)}
  className="w-full pl-10 sm:pl-12 pr-4 py-2.5 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-sm sm:text-base"
/>
                {searchLoading && (
                  <div className="absolute right-3 sm:right-4 top-1/2 transform -translate-y-1/2 text-blue-500 text-xs sm:text-sm font-medium">
                    Searching...
                  </div>
                )}
              </div>
            </div>

            {/* Filters */}
            <div className="flex flex-wrap gap-3 sm:gap-4 items-center">
              {/* Start Date */}
              <div className="relative flex-1 min-w-[140px]">
                <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* End Date */}
              <div className="relative flex-1 min-w-[140px]">
                <FaCalendarAlt className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full pl-9 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                />
              </div>

              {/* Payment Method */}
              <div className="relative flex-1 min-w-[180px]">
                <FaFilter className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                <select
                  value={paymentMethodFilter}
                  onChange={(e) => setPaymentMethodFilter(e.target.value)}
                  className="w-full pl-9 pr-6 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-sm"
                >
                  <option value="all">All Payment Methods</option>
                  <option value="prepaid">Prepaid</option>
                  <option value="cod">COD</option>
                </select>
              </div>
            </div>
          </div>

          {/* Tabs Section */}
          <div className="mb-6 lg:mb-8">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div className="border-b border-gray-200 overflow-hidden">
                <div className="flex gap-1 -mb-px overflow-x-auto scrollbar-hide">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      className={`px-3 sm:px-4 py-2.5 sm:py-3 font-medium text-xs sm:text-sm transition-colors duration-200 whitespace-nowrap border-b-2 flex-shrink-0 bg-white ${
                        activeTab === tab.id
                          ? "text-blue-600 border-blue-200 bg-blue-100 underline decoration-2 underline-offset-4 hover:bg-blue-200"
                          : "text-gray-600 border-transparent hover:text-gray-800 hover:border-gray-300 hover:bg-blue-200"
                      }`}
                      onClick={() => handleTabChange(tab.id)}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Debug Info */}
          {/* {process.env.NODE_ENV === 'development' && (
            <div className="mb-4 p-2 bg-yellow-100 text-yellow-800 text-xs rounded">
              Active Tab: {activeTab} | Total Orders: {orders.length} | Filtered Orders: {displayOrders.length} | Show Modal: {showModal.toString()} | Selected Order: {selectedOrder ? selectedOrder.id : 'None'}
            </div>
          )} */}

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 sm:px-6 py-3 sm:py-4 rounded-lg mb-4 sm:mb-6 text-sm sm:text-base">
              {error}
            </div>
          )}

          {/* Content based on active tab */}
       {activeTab === "return-inventory" ? (
  <div className="space-y-6">
    {/* RTO Inventory Header with Tabs */}
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <div>
          <h2 className="text-lg font-semibold text-gray-800">
            RTO Management
          </h2>
          <p className="text-sm text-gray-600">
            Manage returned items and view return logs
          </p>
        </div>
      </div>

      {/* Sub Tabs */}
      <div className="border-b border-gray-200">
        <div className="flex gap-1 -mb-px">
    <button
  className={`px-4 py-2 font-medium text-sm transition-colors duration-200 border-b-2 ${
    rtoActiveTab === "inventory"
      ? "text-blue-50 border-transparent hover:text-gray-800 hover:border-gray-300" // ACTIVE now looks like your old inactive
      : "text-blue-600 border-blue-600 bg-blue-50" // INACTIVE now looks like your old active
  }`}
  onClick={() => setRtoActiveTab("inventory")}
>
  Return Inventory
</button>
          <button
            className={`px-4 py-2 font-medium text-sm transition-colors duration-200 border-b-2 ${
              rtoActiveTab === "logs"
                 ? "text-blue-50 border-transparent hover:text-gray-800 hover:border-gray-300" // ACTIVE now looks like your old inactive
      : "text-blue-600 border-blue-600 bg-blue-50" // INACTIVE now looks like your old active
            }`}
            onClick={() => setRtoActiveTab("logs")}
          >
            Return Log
          </button>
        </div>
      </div>
    </div>

    {/* Content based on active sub-tab */}
    {rtoActiveTab === "inventory" ? (
      // Existing RTO Inventory Content
      <>
        {rtoLoading ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="text-gray-500 text-base">Loading Return inventory...</p>
            </div>
          </div>
        ) : rtoInventory.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2 2v-5m16 0h-2M4 13h2m13-8V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v1M7 6V4a1 1 0 011-1h4a1 1 0 011 1v2" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">No return inventory found</h3>
                <p className="text-gray-500 text-sm mt-1">There are currently no returned items in your inventory.</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6">
            {renderRtoInventoryCards()}
          </div>
        )}
      </>
    ) : (
      // New Return Log Content
      <>
        {returnLogsLoading ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
            <div className="flex flex-col items-center justify-center space-y-4">
              <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="text-gray-500 text-base">Loading return logs...</p>
            </div>
          </div>
        ) : returnLogs.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-12">
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto">
                <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
              </div>
              <div>
                <h3 className="text-lg font-medium text-gray-900">No return logs found</h3>
                <p className="text-gray-500 text-sm mt-1">There are currently no received returns to display.</p>
              </div>
            </div>
          </div>
        ) : (
          renderReturnLogsTable()
        )}
      </>
    )}
  </div>
  // Rest of your existing content for other tabs
          ) : (
            <>
              {/* Orders List: Card View for Mobile and Tablet */}
              <div className="grid grid-cols-1 gap-4 lg:hidden">
                {displayOrders.map((order) => (
                  <div
                    key={order.id}
                    className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-5 space-y-4"
                  >
                    <div className="flex justify-between items-start gap-3">
                      <div className="min-w-0 flex-1">
                        <p className="font-bold text-blue-600 hover:underline cursor-pointer md:text-sm text-xl truncate">
                          {order.Storeorder_id || "N/A"}
                        </p>
                        <p className="text-xs sm:text-sm text-gray-500 truncate">
                          Unitee ID: {order.id}
                        </p>
                      </div>
                      <span
                        className={`inline-flex px-2 sm:px-3 py-1 text-xs font-semibold rounded-full flex-shrink-0 ${getStatusColor(
                          order.tracking_status
                        )}`}
                      >
                        {order.tracking_status || "Pending"}
                      </span>
                    </div>
                    <div>
                      <p className="font-medium text-gray-900 text-sm sm:text-base truncate w-min">
                        {order.billing_customer_name || "N/A"}
                      </p>
                      <p className="text-xs sm:text-sm text-gray-600 truncate">
                        {order.order_items?.[0]?.sku || "N/A"}
                      </p>
                    </div>
                    <div className="border-t border-gray-100 pt-4 flex justify-between items-center">
                      <div>
                        <p className="font-bold text-green-600 text-base sm:text-lg">
                          {formatPrice(order.total)}
                        </p>
                        <p className="text-xs sm:text-sm text-gray-500">
                          Date: {formatDate(order.order_date)}
                        </p>
                      </div>
                      <span
                        className={`inline-flex px-2 sm:px-3 py-1 text-xs font-semibold rounded-full ${getPaymentMethodColor(
                          order.payment_method
                        )}`}
                      >
                        {order.payment_method || "N/A"}
                      </span>
                    </div>
                    <div className="flex gap-2 pt-2">
                      <button
                        onClick={() => {
                          console.log(
                            "View button clicked for order:",
                            order.id
                          );
                          handleViewOrder(order.id);
                        }}
                        disabled={orderDetailLoading}
                        className="flex-1 p-2 sm:p-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 active:bg-blue-700 transition-colors duration-200 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium disabled:bg-gray-400"
                        title="View Details"
                      >
                        <FaEllipsisH className="text-xs sm:text-sm" /> View
                      </button>
                      {order.SalesinvoiceUrl && (
                        <button
                          onClick={() =>
                            window.open(order.SalesinvoiceUrl, "_blank")
                          }
                          className="flex-1 p-2 sm:p-2.5 bg-green-500 text-white rounded-lg hover:bg-green-600 active:bg-green-700 transition-colors duration-200 flex items-center justify-center gap-2 text-xs sm:text-sm font-medium"
                          title="Download Invoice"
                        >
                          <FaDownload className="text-xs sm:text-sm" /> Download
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Orders List: Table View for Desktop */}
              <div className="hidden lg:block bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="w-full table-auto ">
<thead className="bg-gray-50">
  <tr>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider whitespace-nowrap">
      {activeTab === "returns" ? "AWB" : "Order ID"}
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      {activeTab === "returns" ? "Return ID" : "Unitee ID"}
    </th>
    <th className="px-8 py-3 w-0 whitespace-nowrap text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      {activeTab === "returns" ? "Pickup Name" : "Customer"}
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      Product
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      Date
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      Total
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      Payment
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      Status
    </th>
    <th className="px-2 py-3 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
      Actions
    </th>
  </tr>
</thead>
                    <tbody className="divide-y divide-gray-200">
                      {displayOrders.map((order) => (
                        <tr
                          key={order.id}
                          className="hover:bg-gray-50 transition-colors duration-200"
                        >
                          <td className="px-2 py-3">
                            <span className="text-blue-600 font-medium cursor-pointer hover:underline text-sm">
                              {order.Storeorder_id || order.awb_code || "N/A"}
                            </span>
                          </td>
                          <td className="px-2 py-3">
                            <span className="font-mono text-sm text-gray-500">
                              {order.id}
                            </span>
                          </td>
                          <td className="px-8 py-3 w-0 max-w-0 whitespace-nowrap overflow-hidden text-ellipsis">
                            <span className="font-medium text-gray-900 text-sm">
                              {order.billing_customer_name ||order.pickup_name || "N/A"}
                            </span>
                          </td>

                          <td className="px-2 py-3">
                            <span className="text-gray-900 truncate block text-sm">
                              {order.order_items?.[0]?.sku || "N/A"}
                            </span>
                          </td>
                          <td className="px-2 py-3">
                            <span className="text-sm text-gray-500">
                              {formatDate(order.order_date)}
                            </span>
                          </td>
                          <td className="px-2 py-3">
                            <span className="font-bold text-green-600 text-sm">
                              {formatPrice(order.total)}
                            </span>
                          </td>
                          <td className="px-2 py-3">
                            <span
                              className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${getPaymentMethodColor(
                                order.payment_method
                              )}`}
                            >
                              {order.payment_method || "N/A"}
                            </span>
                          </td>
                          <td className="px-2 py-3">
                            <span
                              className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${getStatusColor(
                                order.tracking_status
                              )}`}
                            >
                              {order.tracking_status || "Pending"}
                            </span>
                          </td>
                          <td className="px-2 py-3">
                            <div className="flex gap-2">
                              <button
                                onClick={() => {
                                  console.log(
                                    "View button clicked for order:",
                                    order.id
                                  );
                                  handleViewOrder(order.id);
                                }}
                                disabled={orderDetailLoading}
                                className="p-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 active:bg-blue-700 transition-colors duration-200 disabled:bg-gray-400"
                                title="View Details"
                              >
                                <FaEllipsisH className="w-4 h-4" />
                              </button>
                              {order.SalesinvoiceUrl && (
                                <button
                                  onClick={() =>
                                    window.open(order.SalesinvoiceUrl, "_blank")
                                  }
                                  className="p-2 bg-green-500 text-white rounded-lg hover:bg-green-600 active:bg-green-700 transition-colors duration-200"
                                  title="Download Invoice"
                                >
                                  <FaDownload className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </>
          )}
          {/* Order Details Modal */}
          {showModal && selectedOrder && (
            <div
              className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
              onClick={(e) => {
                // Close modal when clicking on backdrop
                if (e.target === e.currentTarget) {
                  closeModal();
                }
              }}
            >
               <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                {/* Modal Header */}
  <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white">
                  <h2 className="text-xl font-bold text-gray-800">
                    {isReturnOrder(selectedOrder)
                      ? "Return Order Details"
                      : "Order Details"}{" "}
                    - {getOrderIdDisplay(selectedOrder)}
                  </h2>
                   <div className="flex items-center gap-3">
                    {/* Remove Book Return Button for return orders, only show for regular delivered orders */}
                    {!isReturnOrder(selectedOrder) &&
                      isOrderDelivered(selectedOrder) && (
                <>
                          <button
                            onClick={() => openReturnModal(selectedOrder)}
                            disabled={returnLoading}
                          className="px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 active:bg-orange-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm flex items-center gap-2"
                          >
                            <FaTruck className="w-4 h-4" />
                            Book Return
                          </button>
                          {/* <button
                            onClick={() => openSizeExchangeModal(selectedOrder)}
                            disabled={sizeExchangeLoading}
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 active:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm flex items-center gap-2"
                          >
                         <FaBox className="w-4 h-4" />
                            Size Exchange
                          </button> */}
                          {/* <button
                            onClick={() => openProductExchangeModal(selectedOrder)}
                            disabled={productExchangeLoading}
                            className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 active:bg-purple-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm flex items-center gap-2"
                          >
                            <FaBox className="w-4 h-4" />
                            Product Exchange
                          </button> */}
                        </>
                      )}
                    <button
                      onClick={closeModal}
                      className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 bg-white"
                    >
                        <FaTimes className="w-5 h-5 text-gray-500" />
                    </button>
                  </div>
                </div>

                {/* Modal Content */}
            <div className="p-6 space-y-6">
                  {/* Order Summary */}
                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div className="bg-blue-50 p-4 rounded-lg">
                      <div className="flex items-center gap-2">
                       <FaBox className="text-blue-600" />
                        <span className="text-sm font-medium text-blue-600">
                          {isReturnOrder(selectedOrder)
                            ? "Return Order ID"
                            : "Order ID"}
                        </span>
                      </div>
                      <p className="font-bold text-gray-800 mt-1">
                        {getOrderIdDisplay(selectedOrder)}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {isReturnOrder(selectedOrder)
                          ? `Return ID: ${selectedOrder.id}`
                          : `Unitee ID: ${selectedOrder.id}`}
                      </p>
                    </div>

                      <div className="bg-green-50 p-4 rounded-lg">
                      <div className="flex items-center gap-2">
                       <FaMoneyBillWave className="text-green-600" />
                        <span className="text-sm font-medium text-green-600">
                          Total Amount
                        </span>
                      </div>
                       <p className="font-bold text-gray-800 mt-1">
                        {formatPrice(getOrderTotal(selectedOrder))}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        {isReturnOrder(selectedOrder)
                          ? selectedOrder.payment_type
                          : selectedOrder.payment_method}
                      </p>
                    </div>

                      <div className="bg-purple-50 p-4 rounded-lg">
                      <div className="flex items-center gap-2">
                          <FaTruck className="text-purple-600" />
                        <span className="text-sm font-medium text-purple-600">
                          Status
                        </span>
                      </div>
                       <p className="font-bold text-gray-800 mt-1">
                        {selectedOrder.tracking_status}
                      </p>
                      {selectedOrder.awb_code && (
                        <p className="text-xs text-gray-500 mt-1">
                          AWB: {selectedOrder.awb_code}
                        </p>
                      )}
                    </div>

                       <div className="bg-orange-50 p-4 rounded-lg">
                      <div className="flex items-center gap-2">
                        <FaCalendarAlt className="text-orange-600" />
                        <span className="text-sm font-medium text-orange-600">
                          {isReturnOrder(selectedOrder)
                            ? "Return Date"
                            : "Order Date"}
                        </span>
                      </div>
                       <p className="font-bold text-gray-800 mt-1">
                        {formatDate(selectedOrder.order_date)}
                      </p>
                      {selectedOrder.courier_name && (
                        <p className="text-xs text-gray-500 mt-1">
                          {selectedOrder.courier_name}
                        </p>
                      )}
                    </div>
                  </div>
                  {/* // Update the Customer Information section for return orders */}
                  {isReturnOrder(selectedOrder) ? (
                    // Return Order Customer Information
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <FaUser className="text-blue-600" />
                        Pickup Information
                      </h3>
                      <div className="space-y-2 text-sm">
                        <p className="font-medium">
                          {selectedOrder.pickup_name}
                        </p>
                        <div className="flex items-start gap-2">
                          <FaMapMarkerAlt className="text-gray-400 mt-1 flex-shrink-0" />
                          <div>
                            <p>{selectedOrder.pickup_address_line_one}</p>
                            {selectedOrder.pickup_address_line_two && (
                              <p>{selectedOrder.pickup_address_line_two}</p>
                            )}
                            <p>
                              {selectedOrder.pickup_city},{" "}
                              {selectedOrder.pickup_state}{" "}
                              {selectedOrder.pickup_pin_code}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          <FaPhone className="text-gray-400" />
                          <p>{selectedOrder.pickup_phone}</p>
                        </div>
                        <div className="flex items-center gap-2">
                          <FaEnvelope className="text-gray-400" />
                          <p>{selectedOrder.pickup_email}</p>
                        </div>
                      </div>

                      {/* Return Specific Information */}
                      <div className="mt-4 pt-4 border-t border-gray-200">
                        <h4 className="font-medium text-gray-800 mb-2">
                          Return Details
                        </h4>
                        <div className="space-y-1 text-sm text-gray-600">
                          <p>
                            <strong>Return Reason ID:</strong>{" "}
                            {selectedOrder.return_reason_id}
                          </p>
                          <p>
                            <strong>Customer Request:</strong>{" "}
                            {selectedOrder.customer_request}
                          </p>
                          {selectedOrder.reason_comment && (
                            <p>
                              <strong>Reason Comment:</strong>{" "}
                              {selectedOrder.reason_comment}
                            </p>
                          )}
                          <p>
                            <strong>Warehouse ID:</strong>{" "}
                            {selectedOrder.warehouse_id}
                          </p>
                          <p>
                            <strong>Shipment Type:</strong>{" "}
                            {selectedOrder.shipment_type}
                          </p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="bg-gray-50 p-4 rounded-lg">
                      <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                        <FaUser className="text-blue-600" />
                        Customer Information
                      </h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {/* Billing Information */}
                        <div>
                          <h4 className="font-medium text-gray-700 mb-3">
                            Billing Address
                          </h4>
                          <div className="space-y-2 text-sm">
                            <p className="font-medium">
                              {selectedOrder.billing_customer_name}{" "}
                              {selectedOrder.billing_last_name}
                            </p>
                            <div className="flex items-start gap-2">
                              <FaMapMarkerAlt className="text-gray-400 mt-1 flex-shrink-0" />
                              <div>
                                <p>{selectedOrder.billing_address}</p>
                                {selectedOrder.billing_address_2 && (
                                  <p>{selectedOrder.billing_address_2}</p>
                                )}
                                <p>
                                  {selectedOrder.billing_city},{" "}
                                  {selectedOrder.billing_state}{" "}
                                  {selectedOrder.billing_pincode}
                                </p>
                                <p>{selectedOrder.billing_country}</p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <FaPhone className="text-gray-400" />
                              <p>{selectedOrder.billing_phone}</p>
                            </div>
                            <div className="flex items-center gap-2">
                              <FaEnvelope className="text-gray-400" />
                              <p>{selectedOrder.billing_email}</p>
                            </div>
                          </div>
                        </div>

                        {/* Shipping Information */}
                        <div>
                          <h4 className="font-medium text-gray-700 mb-3">
                            Shipping Address
                          </h4>
                          <div className="space-y-2 text-sm">
                            <p className="font-medium">
                              {selectedOrder.shipping_customer_name}{" "}
                              {selectedOrder.shipping_last_name}
                            </p>
                            <div className="flex items-start gap-2">
                              <FaMapMarkerAlt className="text-gray-400 mt-1 flex-shrink-0" />
                              <div>
                                <p>{selectedOrder.shipping_address}</p>
                                {selectedOrder.shipping_address_2 && (
                                  <p>{selectedOrder.shipping_address_2}</p>
                                )}
                                <p>
                                  {selectedOrder.shipping_city},{" "}
                                  {selectedOrder.shipping_state}{" "}
                                  {selectedOrder.shipping_pincode}
                                </p>
                                <p>{selectedOrder.shipping_country}</p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              <FaPhone className="text-gray-400" />
                              <p>{selectedOrder.shipping_phone}</p>
                            </div>
                            <div className="flex items-center gap-2">
                              <FaEnvelope className="text-gray-400" />
                              <p>{selectedOrder.shipping_email}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}


                  {/* Order Items */}


                  <div className="bg-white border border-gray-200 rounded-lg p-4">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                      <FaBox className="text-green-600" />
                      {isReturnOrder(selectedOrder) ? "Return Items" : "Order Items"}
                    </h3>
                  <div className="space-y-4">
                      {selectedOrder.order_items?.map((item, index) => (
                        <div
                          key={index}
                         className="flex items-start gap-4 p-4 bg-gray-50 rounded-lg"
                        >


                        {/* Product Images - only for regular orders */}
{!isReturnOrder(selectedOrder) && (
          <div className="flex gap-2">
            {item.design?.frontImage && (
              <img
                src={item.design.frontImage}
                alt="Product Front"
                className="w-16 h-16 object-cover rounded-lg border"
              />
            )}
            {item.design?.backImage && (
              <img
                src={item.design.backImage}
                alt="Product Back"
                className="w-16 h-16 object-cover rounded-lg border"
              />
            )}
          </div>
        )}

                          {/* Product Details */}
                          <div className="flex-1">
                            <h4 className="font-medium text-gray-800">
                              {item.name}
                            </h4>
                            <p className="text-sm text-gray-600">
                              Ordered SKU:{" "}
                              <span className="font-semibold">{item.sku}</span>
                            </p>
        

                               {isReturnOrder(selectedOrder) && (
            <div className="mt-2 text-sm text-gray-600">
              <p>Category: {item.product_category}</p>
              <p>HSN: {item.hsn}</p>
              {item.discount && <p>Discount: {item.discount}</p>}
            </div>
          )}
                            {/* Display all SKUs if available */}
                         
                    {item.design?.SKUs &&
                              item.design.SKUs.length > 1 && (
                                <div className="mt-1 text-sm text-gray-500">
                                  <p>Available SKUs:</p>
                                  <div className="flex flex-wrap gap-2 mt-1">
                                    {item.design.SKUs.map((sku, i) => (
                                      <span
                                        key={i}
                                        className={`px-2 py-1 rounded border text-xs ${
                                          sku === item.sku
                                            ? "bg-green-100 border-green-400 text-green-800 font-semibold"
                                            : "bg-gray-100 border-gray-300"
                                        }`}
                                      >
                                        {sku}
                                      </span>
                                    ))}
                                  
                                  
                                  </div>
                               
                               
                             
                                  </div>
                              
                              )}

                        {!isReturnOrder(selectedOrder) && item.design && (
            <div className="mt-2 text-sm text-gray-600">
              <p>Design: {item.design.designName}</p>
              <p>Product: {item.design.productName}</p>
              <p>GSM: {item.design.productGSM}</p>
              <p>Print Method: {formatPrintMethod(item.design.printMethod)}</p>
              <p>Pickup Location: {item.design.pickupLocation}</p>
            </div>
          )}
                          </div>

                  {/* Price and Quantity */}
                          <div className="text-right">
                            <p className="font-bold text-lg text-green-600">
                              {formatPrice(item.selling_price)}
                            </p>
                            <p className="text-sm text-gray-600">
                              Qty: {item.units}
                            </p>
                            {item.itemTotalPrice && (
                              <p className="text-sm text-gray-600">
                                Total: {formatPrice(item.itemTotalPrice)}
                              </p>
                            )}

                              </div>
                            </div>
                      ))}
                    </div>
                  </div>



{/* // Update Financial Summary section for return orders */}
{isReturnOrder(selectedOrder) ? (
  // Return Order Financial Summary
  <div className="bg-white border border-gray-200 rounded-lg p-4">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Return Summary</h3>
    <div className="space-y-2">
      <div className="flex justify-between">
        <span className="text-gray-600">Return Total:</span>
        <span className="font-medium">{formatPrice(getOrderTotal(selectedOrder))}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-gray-600">Payment Type:</span>
        <span className="font-medium">{selectedOrder.payment_type}</span>
      </div>
      <div className="flex justify-between">
        <span className="text-gray-600">Return Reason:</span>
        <span className="font-medium">ID: {selectedOrder.return_reason_id}</span>
      </div>
      <div className="border-t pt-2 flex justify-between text-lg font-bold">
        <span>Customer Request:</span>
        <span className={`${selectedOrder.customer_request === 'REFUND' ? 'text-red-600' : 'text-blue-600'}`}>
          {selectedOrder.customer_request}
        </span>
      </div>
    </div>
  </div>
) : (
  // Regular Order Financial Summary (existing code)
  <div className="bg-white border border-gray-200 rounded-lg p-4">
    <h3 className="text-lg font-semibold text-gray-800 mb-4">Financial Summary</h3>
    <div className="space-y-2">
      <div className="flex justify-between">
        <span className="text-gray-600">Subtotal:</span>
        <span className="font-medium">{formatPrice(selectedOrder.sub_total)}</span>
      </div>
      {selectedOrder.total_discount > 0 && (
        <div className="flex justify-between text-red-600">
          <span>Discount:</span>
          <span>-{formatPrice(selectedOrder.total_discount)}</span>
        </div>
      )}
      {selectedOrder.shipping_charge > 0 && (
        <div className="flex justify-between">
          <span className="text-gray-600">Shipping:</span>
          <span className="font-medium">{formatPrice(selectedOrder.shipping_charge)}</span>
        </div>
      )}
      {selectedOrder.UniteeShipping && (
        <div className="flex justify-between">
          <span className="text-gray-600">Unitee Shipping:</span>
          <span className="font-medium">{formatPrice(selectedOrder.UniteeShipping)}</span>
        </div>
      )}
      <div className="border-t pt-2 flex justify-between text-lg font-bold">
        <span>Total:</span>
        <span className="text-green-600">{formatPrice(selectedOrder.total)}</span>
      </div>
      {selectedOrder.total_outstanding > 0 && (
        <div className="flex justify-between text-red-600 font-medium">
          <span>Outstanding:</span>
          <span>{formatPrice(selectedOrder.total_outstanding)}</span>
        </div>
      )}
    </div>
  </div>
)}



                  {/* Fulfillment Information */}
                  {selectedOrder.fulfillment_orders &&
                    selectedOrder.fulfillment_orders.length > 0 && (
                      <div className="bg-white border border-gray-200 rounded-lg p-4">
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">
                          Fulfillment Information
                        </h3>
                        {selectedOrder.fulfillment_orders.map(
                          (fulfillment, index) => (
                            <div
                              key={fulfillment.id}
                              className="mb-4 p-3 bg-gray-50 rounded-lg"
                            >
                              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <div>
                                  <p className="text-sm">
                                    <strong>Status:</strong>{" "}
                                    {fulfillment.status}
                                  </p>
                                  <p className="text-sm">
                                    <strong>Request Status:</strong>{" "}
                                    {fulfillment.request_status}
                                  </p>
                                  {fulfillment.fulfill_at && (
                                    <p className="text-sm">
                                      <strong>Fulfill At:</strong>{" "}
                                      {formatDate(fulfillment.fulfill_at)}
                                    </p>
                                  )}
                                </div>
                                <div>
                                  {fulfillment.assigned_location && (
                                    <div className="text-sm">
                                      <strong>Assigned Location:</strong>
                                      <p>
                                        {fulfillment.assigned_location.name}
                                      </p>
                                      <p>
                                        {fulfillment.assigned_location.address1}
                                      </p>
                                      <p>
                                        {fulfillment.assigned_location.city},{" "}
                                        {fulfillment.assigned_location.province}
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    )}


                  {/* Additional Information */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Package Details */}
 <div className="bg-white border border-gray-200 rounded-lg p-4">
    <h3 className="text-lg font-semibold text-gray-800 mb-3">
      {isReturnOrder(selectedOrder) ? "Return Package Details" : "Package Details"}
    </h3>
    <div className="space-y-2 text-sm">
      <p><strong>Dimensions:</strong> {selectedOrder.length || selectedOrder.width} x {selectedOrder.breadth || selectedOrder.width} x {selectedOrder.height} cm</p>
      <p><strong>Weight:</strong> {selectedOrder.weight} {isReturnOrder(selectedOrder) ? 'g' : 'kg'}</p>
      {isReturnOrder(selectedOrder) ? (
        <>
          <p><strong>Order Type:</strong> {selectedOrder.order_type}</p>
          <p><strong>Warehouse ID:</strong> {selectedOrder.warehouse_id}</p>
        </>
      ) : (
        <>
          <p><strong>Pickup Location:</strong> {selectedOrder.pickup_location}</p>
          {selectedOrder.shippingPreference && (
            <p><strong>Shipping Preference:</strong> {selectedOrder.shippingPreference}</p>
          )}
        </>
      )}
    </div>
  </div>

  {/* Order Status Timeline */}
  <div className="bg-white border border-gray-200 rounded-lg p-4">
    <h3 className="text-lg font-semibold text-gray-800 mb-3">
      {isReturnOrder(selectedOrder) ? "Return Timeline" : "Order Timeline"}
    </h3>
    <div className="space-y-2 text-sm">
      <p><strong>Created:</strong> {formatDate(selectedOrder.createdAt || selectedOrder.order_date)}</p>
      {selectedOrder.updatedAt && (
        <p><strong>Last Updated:</strong> {formatDate(selectedOrder.updatedAt._seconds ? new Date(selectedOrder.updatedAt._seconds * 1000) : selectedOrder.updatedAt)}</p>
      )}
      {selectedOrder.tracking_last_updated && (
        <p><strong>Tracking Updated:</strong> {formatDate(selectedOrder.tracking_last_updated._seconds ? new Date(selectedOrder.tracking_last_updated._seconds * 1000) : selectedOrder.tracking_last_updated)}</p>
      )}
      {selectedOrder.status_time && (
        <p><strong>Status Time:</strong> {selectedOrder.status_time}</p>
      )}
      {selectedOrder.cancelledAt && (
        <p className="text-red-600"><strong>Cancelled:</strong> {formatDate(selectedOrder.cancelledAt._seconds ? new Date(selectedOrder.cancelledAt._seconds * 1000) : selectedOrder.cancelledAt)}</p>
      )}
    </div>
  </div>

                  </div>
                  {/* Comments */}
                  {selectedOrder.comment && (
                    <div className="bg-white border border-gray-200 rounded-lg p-4">
                      <h3 className="text-lg font-semibold text-gray-800 mb-3">
                        Comments
                      </h3>
                      <p className="text-gray-700">{selectedOrder.comment}</p>
                    </div>
                  )}
                </div>

{/* // Update Modal Footer to remove invoice button for return orders */}
<div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
  {!isReturnOrder(selectedOrder) && selectedOrder.SalesinvoiceUrl && (
    <button
      onClick={() => window.open(selectedOrder.SalesinvoiceUrl, '_blank')}
      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors duration-200 flex items-center gap-2"
    >
      <FaDownload /> Download Invoice
    </button>
  )}
  <button
    onClick={closeModal}
    className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200"
  >
    Close
  </button>
</div>
              </div>
            </div>
          )}
          {/* Return Order Form Modal */}
           {showReturnModal && selectedOrder && !showSizeExchangeModal && !showSizeExchangeConfirmModal && !showConfirmModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                {/* Return Modal Header */}
                <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white">
                  <h2 className="text-xl font-bold text-gray-800">
                    Return Order - {selectedOrder.Storeorder_id}
                  </h2>
                  <button
                    onClick={closeReturnModal}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 bg-white"
                  >
                    <FaTimes className="w-5 h-5 text-gray-500" />
                  </button>
                </div>

                {/* Return Form Content */}
                <div className="p-6 space-y-6">
                  {/* Pickup Information */}
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                      <FaMapMarkerAlt className="text-blue-600" />
                      Pickup Information
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pickup Contact Name{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={returnFormData.pickup_customer_name}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "pickup_customer_name",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          required
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pickup Phone <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="tel"
                          value={returnFormData.pickup_phone}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "pickup_phone",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          required
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pickup Email <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="email"
                          value={returnFormData.pickup_email}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "pickup_email",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          required
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pickup Pincode <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={returnFormData.pickup_pincode}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "pickup_pincode",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          required
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Pickup Address <span className="text-red-500">*</span>
                      </label>
                      <textarea
                        value={returnFormData.pickup_address}
                        onChange={(e) =>
                          handleReturnFormChange(
                            "pickup_address",
                            e.target.value
                          )
                        }
                        rows="3"
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        required
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Pickup Address 2 (Optional)
                      </label>
                      <input
                        type="text"
                        value={returnFormData.pickup_address_2}
                        onChange={(e) =>
                          handleReturnFormChange(
                            "pickup_address_2",
                            e.target.value
                          )
                        }
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pickup City <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={returnFormData.pickup_city}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "pickup_city",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          required
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Pickup State <span className="text-red-500">*</span>
                        </label>
                        <input
                          type="text"
                          value={returnFormData.pickup_state}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "pickup_state",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  {/* Return Details */}
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                      <FaBox className="text-orange-600" />
                      Return Details
                    </h3>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Return Reason
                        </label>
                        <select
                          value={returnFormData.return_reason_id}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "return_reason_id",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                        >
                          <option value="1">Wrong Item Received</option>
                          <option value="2">Damaged Item</option>
                          <option value="3">Quality Issues</option>
                          <option value="4">Size Issues</option>
                          <option value="5">Other</option>
                        </select>
                      </div>

                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Customer Request
                        </label>
                        <select
                          value={returnFormData.customer_request}
                          onChange={(e) =>
                            handleReturnFormChange(
                              "customer_request",
                              e.target.value
                            )
                          }
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                        >
                          <option value="REFUND">Refund</option>
                        </select>
                      </div>
                    </div>

                    <div>
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Reason Comment
                      </label>
                      <textarea
                        value={returnFormData.reason_comment}
                        onChange={(e) =>
                          handleReturnFormChange(
                            "reason_comment",
                            e.target.value
                          )
                        }
                        rows="3"
                        placeholder="Please provide additional details about the return..."
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                      />
                    </div>
                  </div>

                  {/* Product Selection */}
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800 flex items-center gap-2">
                      <FaBox className="text-green-600" />
                      Select Items to Return
                    </h3>

                    <div className="space-y-3 max-h-60 overflow-y-auto">
                      {returnFormData.selected_items.map((item, index) => (
                        <div
                          key={index}
                          className="border border-gray-200 rounded-lg p-4 bg-gray-50"
                        >
                          <div className="flex items-start gap-4">
                            {/* Checkbox */}
                            <input
                              type="checkbox"
                              checked={item.selected}
                              onChange={(e) =>
                                handleItemSelection(index, e.target.checked)
                              }
                              className="mt-1 h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                            />

                            {/* Product Images */}
                            <div className="flex gap-2">
                              {item.design?.frontImage && (
                                <img
                                  src={item.design.frontImage}
                                  alt="Product Front"
                                  className="w-12 h-12 object-cover rounded-lg border"
                                />
                              )}
                            </div>

                            {/* Product Details */}
                            <div className="flex-1">
                              <h4 className="font-medium text-gray-800">
                                {item.name}
                              </h4>
                              <p className="text-sm text-gray-600">
                                SKU: {item.sku}
                              </p>
                              <p className="text-sm text-gray-600">
                                Price: {formatPrice(item.selling_price)}
                              </p>
                              <p className="text-sm text-gray-600">
                                Original Qty: {item.units}
                              </p>
                            </div>

                            {/* Quantity Input */}
                            <div className="flex flex-col items-end gap-2">
                              <label className="text-sm font-medium text-gray-700">
                                Return Qty:
                              </label>
                              <input
                                type="number"
                                min="0"
                                max={item.units}
                                value={item.return_quantity}
                                onChange={(e) =>
                                  handleQuantityChange(index, e.target.value)
                                }
                                disabled={!item.selected}
                                className="w-20 px-2 py-1 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* Selected Items Summary */}
                    <div className="bg-blue-50 p-3 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>Selected Items:</strong>{" "}
                        {
                          returnFormData.selected_items.filter(
                            (item) => item.selected && item.return_quantity > 0
                          ).length
                        }{" "}
                        items,
                        <strong> Total Qty:</strong>{" "}
                        {returnFormData.selected_items.reduce(
                          (sum, item) =>
                            sum + (item.selected ? item.return_quantity : 0),
                          0
                        )}
                      </p>
                    </div>
                  </div>

                  {/* Order Summary */}
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-800 mb-2">
                      Order Summary
                    </h4>
                    <div className="text-sm text-gray-600 space-y-1">
                      <p>
                        <strong>Order ID:</strong> {selectedOrder.Storeorder_id}
                      </p>
                      <p>
                        <strong>Total Amount:</strong>{" "}
                        {formatPrice(selectedOrder.total)}
                      </p>
                      <p>
                        <strong>Payment Method:</strong>{" "}
                        {selectedOrder.payment_method}
                      </p>
                      <p>
                        <strong>Items:</strong>{" "}
                        {selectedOrder.order_items?.length || 0}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Return Modal Footer */}
                <div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
                  <button
                    onClick={closeReturnModal}
                    className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={() => handleBookReturn(selectedOrder)}
                    disabled={
                      returnLoading ||
                      !returnFormData.pickup_customer_name ||
                      !returnFormData.pickup_phone ||
                      !returnFormData.pickup_email ||
                      !returnFormData.pickup_address ||
                      !returnFormData.selected_items.some(
                        (item) => item.selected && item.return_quantity > 0
                      )
                    }
                    className="px-6 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 active:bg-orange-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium flex items-center gap-2"
                  >
                    {returnLoading ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                        Creating Return...
                      </>
                    ) : (
                      <>
                        <FaTruck className="w-4 h-4" />
                        Create Return Order
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Loading Modal */}
          {orderDetailLoading && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <div className="bg-white rounded-lg p-6 flex items-center gap-3">
                <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
                <span className="text-gray-700">Loading order details...</span>
              </div>
            </div>
          )}
          {/* Common elements for both views */}
{activeTab !== "return-inventory" && displayOrders.length === 0 && !loading && !returnOrdersLoading && (
  <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
    <p className="text-gray-500 text-base sm:text-lg">
      {activeTab === "returns" 
        ? "No return orders found for the selected filters." 
        : "No orders found for the selected tab."}
    </p>
  </div>
)}

{activeTab !== "return-inventory" && 
 ((activeTab === "returns" && returnOrdersHasMore) || (activeTab !== "returns" && hasMore)) && 
 displayOrders.length > 0 && !searchTerm && (
  <div className="mt-6 lg:mt-8 text-center">
    <button
      onClick={handleLoadMore}
      disabled={loadingMore}
      className="px-6 sm:px-8 py-2.5 sm:py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 active:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium text-sm sm:text-base"
    >
      {loadingMore ? "Loading..." : `Load More ${activeTab === "returns" ? "Return Orders" : "Orders"}`}
    </button>
  </div>
)}

{/* // Confirmation Modal JSX (add this after your return modal) */}
{showConfirmModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4">
    <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
      <div className="p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Confirm Return Order
        </h3>
        <div className="space-y-3 text-sm">
          <div className="flex justify-between">
            <span>Return Cost:</span>
            <span>₹{RETURN_COST}</span>
          </div>
          <div className="flex justify-between">
            <span>Tax ({(TAX_RATE * 100).toFixed(0)}%):</span>
            <span>₹{(RETURN_COST * TAX_RATE).toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-medium border-t pt-2">
            <span>Total Cost:</span>
            <span>₹{TOTAL_COST.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-gray-600">
            <span>Current Balance:</span>
            <span>₹{walletBalance.toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-medium">
            <span>Balance After:</span>
            <span>₹{confirmBalance.toFixed(2)}</span>
          </div>
        </div>
        <div className="flex gap-3 mt-6">
          <button
            onClick={() => setShowConfirmModal(false)}
            className="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={confirmReturnOrder}
            disabled={returnLoading}
            className="flex-1 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700 disabled:bg-gray-400"
          >
            {returnLoading ? "Processing..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
 </div>
          )}

{/* Size Exchange Confirmation Modal (detailed breakdown only) */}
          {showSizeExchangeConfirmModal && !showSizeExchangeModal && !showConfirmModal && !showReturnModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[70] p-4">
    <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
      <div className="p-6">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Confirm Size Exchange
        </h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span>Items Subtotal:</span>
            <span className="font-medium">{formatPrice(sizeExchangeBreakdown.itemsSubtotal)}</span>
          </div>
          <div className="flex justify-between">
            <span>Tax (5% on items):</span>
            <span className="font-medium">{formatPrice(sizeExchangeBreakdown.tax5)}</span>
          </div>
          <div className="flex justify-between">
            <span>Shipping Share:</span>
            <span className="font-medium">{formatPrice(sizeExchangeBreakdown.shippingShare)}</span>
          </div>
          <div className="flex justify-between">
            <span>GST (18% on shipping):</span>
            <span className="font-medium">{formatPrice(sizeExchangeBreakdown.shippingGst18)}</span>
          </div>
          <div className="flex justify-between">
            <span>Return Booking Cost (incl. tax):</span>
            <span className="font-medium">{formatPrice(sizeExchangeBreakdown.returnCostWithTax)}</span>
          </div>
          <div className="border-t pt-2 flex justify-between text-base font-semibold">
            <span>Total Deduction:</span>
            <span className="text-red-600">{formatPrice(sizeExchangeBreakdown.total)}</span>
          </div>
          <div className="flex justify-between text-xs text-gray-600 mt-1">
            <span>Wallet After:</span>
            <span>{formatPrice(parseFloat((walletBalance - sizeExchangeBreakdown.total).toFixed(2)))}</span>
          </div>
        </div>
      </div>
      <div className="p-4 border-t bg-gray-50 flex justify-end gap-3">
        <button
          onClick={() => setShowSizeExchangeConfirmModal(false)}
          className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700"
        >
          Cancel
        </button>
        <button
          onClick={confirmSizeExchange}
          disabled={sizeExchangeLoading}
          className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400"
        >
          {sizeExchangeLoading ? 'Processing...' : 'Confirm Exchange'}
        </button>
      </div>
    </div>
  </div>
)}

          {/* Size Exchange Modal */}
          {showSizeExchangeModal && selectedOrder && !showReturnModal && !showConfirmModal && !showSizeExchangeConfirmModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
              <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
                {/* Size Exchange Modal Header */}
                <div className="flex justify-between items-center p-6 border-b border-gray-200 sticky top-0 bg-white">
                  <h2 className="text-xl font-bold text-gray-800">
                    Size Exchange - {selectedOrder.Storeorder_id}
                  </h2>
                  <button
                    onClick={closeSizeExchangeModal}
                    className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200 bg-white"
                  >
                    <FaTimes className="w-5 h-5 text-gray-500" />
                  </button>
                </div>

                {/* Size Exchange Modal Content */}
                <div className="p-6 space-y-6">
                  {/* Shipping Preference Selector */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Shipping Method for Exchange</label>
                    <select
                      value={exchangeShippingPreference || selectedOrder?.shippingPreference || ''}
                      onChange={(e) => setExchangeShippingPreference(e.target.value)}
                      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                    >
                      <option value="">Default ({selectedOrder?.shippingPreference || 'Surface'})</option>
                      <option value="Air">Air</option>
                      <option value="Surface">Surface</option>
                    </select>
                  </div>
                  {/* Product Selection */}
                  <div className="space-y-4">
                    <h3 className="text-lg font-semibold text-gray-800">
                      Select Products for Size Exchange
                    </h3>
                    
                    {sizeExchangeFormData.selected_items.map((item, index) => (
                      <div key={index} className="border border-gray-200 rounded-lg p-4">
                        <div className="flex items-center justify-between mb-3">
                          <div className="flex items-center space-x-3">
                            <input
                              type="checkbox"
                              checked={item.selected}
                              onChange={(e) => handleSizeExchangeItemSelection(index, e.target.checked)}
                              className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                            />
                            <div>
                              <h4 className="font-medium text-gray-800">{item.product_name}</h4>
                              <p className="text-sm text-gray-600">SKU: {item.sku}</p>
                              <p className="text-sm text-gray-600">
                                Current Size: <span className="font-medium">
                                  {(() => {
                                    // Extract size from SKU (e.g., "u-726633-S" -> "S")
                                    const skuParts = item.sku?.split('-') || [];
                                    const sizeFromSku = skuParts[skuParts.length - 1];
                                    return sizeFromSku || item.size || item.variant_size || 'N/A';
                                  })()}
                                </span>
                              </p>
                              <p className="text-sm text-gray-600">
                                Price: ₹{item.selling_price}
                              </p>
                            </div>
                          </div>
                        </div>

                        {item.selected && (
                          <div className="mt-3">
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                              Select New Size:
                            </label>
                            <select
                              value={item.new_size}
                              onChange={(e) => handleSizeChange(index, e.target.value)}
                              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                            >
                              <option value="">Select Size</option>
                              {/* Extract available sizes from SKU pattern */}
                              {(() => {
                                const skuBase = item.sku?.split('-').slice(0, -1).join('-') || '';
                                const availableSizes = ['S', 'M', 'L', 'XL', 'XXL'];
                                return availableSizes.map(size => (
                                  <option key={size} value={size}>
                                    {size} ({skuBase}-{size})
                                  </option>
                                ));
                              })()}
                            </select>
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {/* Exchange Summary */}
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-medium text-gray-800 mb-2">
                      Exchange Summary
                    </h4>
                    <div className="text-sm text-gray-600 space-y-1">
                      {(() => {
                        const b = computeSizeExchangeBreakdown(sizeExchangeFormData.selected_items, selectedOrder, exchangeShippingPreference || selectedOrder?.shippingPreference);
                        return (
                          <>
                            <p>
                              <strong>Items Selected:</strong> {sizeExchangeFormData.selected_items.filter(i => i.selected && i.new_size && i.new_size !== (i.size || i.variant_size || '')).length}
                            </p>
                            <div className="flex justify-between">
                              <span>Items Subtotal:</span>
                              <span className="font-medium">{formatPrice(b.itemsSubtotal)}</span>
                            </div>

                             {b.neckLabelTotal > 0 && (
                              <div className="flex justify-between">
                                <span>Neck Labels (₹5 each):</span>
                                <span className="font-medium">{formatPrice(b.neckLabelTotal)}</span>
                              </div>
                            )}

                            <div className="flex justify-between">
                               <span>Tax (5%):</span>
                              <span className="font-medium">{formatPrice(b.tax5)}</span>
                            </div>
                            <div className="flex justify-between">
                              <span>Base Shipping ({exchangeShippingPreference || selectedOrder?.shippingPreference || 'Surface'}):</span>
                              <span className="font-medium">{formatPrice(b.baseShipping)}</span>
                            </div>

                             {b.codShipping > 0 && (
                              <div className="flex justify-between">
                                <span>COD Shipping:</span>
                                <span className="font-medium">{formatPrice(b.codShipping)}</span>
                              </div>
                            )}

                            <div className="flex justify-between">
                              <span>Shipping Tax (18%):</span>
                              <span className="font-medium">{formatPrice(b.shippingTax)}</span>
                            </div>
                            <div className="flex justify-between">
                              <span>Return Booking Cost (incl. tax):</span>
                              <span className="font-medium">{formatPrice(b.returnCostWithTax)}</span>
                            </div>
                            <div className="border-t pt-2 flex justify-between text-base font-semibold">
                              <span>Total Deduction:</span>
                              <span className="text-red-600">{formatPrice(b.total)}</span>
                            </div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>

                {/* Size Exchange Modal Footer */}
                <div className="flex justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
                  <button
                    onClick={closeSizeExchangeModal}
                    className="px-4 py-2 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors duration-200"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleSizeExchange}
                    disabled={
                      sizeExchangeLoading ||
                      !sizeExchangeFormData.selected_items.some(
                        (item) => item.selected && item.new_size && item.new_size !== (item.size || item.variant_size || '')
                      )
                    }
                    className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 active:bg-blue-800 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors duration-200 font-medium flex items-center gap-2"
                  >
                    {sizeExchangeLoading ? (
                      <>
                        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                        Processing Exchange...
                      </>
                    ) : (
                      <>
                        <FaBox className="w-4 h-4" />
                        Proceed to Exchange
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Product Exchange Modal */}
      {showProductExchangeModal && selectedOrder && !showReturnModal && !showSizeExchangeModal && !showSizeExchangeConfirmModal && !showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-[60] p-2 sm:p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[95vh] overflow-hidden border border-gray-200 mx-2 sm:mx-0">
                {/* Modal Header */}
                 <div className="flex items-center justify-between p-4 sm:p-8 border-b border-gray-200 bg-white text-white">
                  <h2 className="text-lg sm:text-2xl font-bold flex items-center gap-2 sm:gap-3 flex-1 min-w-0">
                    <FaBox className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" />
                    <span className="truncate">Product Exchange - {getOrderIdDisplay(selectedOrder)}</span>
                  </h2>
                  <button
                    onClick={closeProductExchangeModal}
                    className="p-2 sm:p-3 hover:bg-gray-800 rounded-full transition-colors duration-200 flex-shrink-0 ml-2"
                  >
                    <FaTimes className="w-5 h-5 sm:w-6 sm:h-6" />
                  </button>
                </div>

                {/* Modal Content */}
                <div className="p-4 sm:p-6 space-y-4 sm:space-y-6 max-h-[60vh] overflow-y-auto">
                  {/* Customer Information */}
                  <div className="space-y-6">
                    <h3 className="text-xl font-bold text-black flex items-center gap-3">
                      <FaUser className="w-6 h-6" />
                      Customer Information
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6 bg-gray-50 rounded-xl border border-gray-200">
                      <div className="space-y-1">
                        <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Name</span>
                        <p className="text-lg font-medium text-black">
                          {selectedOrder.shipping_customer_name || selectedOrder.billing_customer_name} {selectedOrder.shipping_last_name || selectedOrder.billing_last_name}
                        </p>
                      </div>
                      <div className="space-y-1">
                        <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Phone</span>
                        <p className="text-lg font-medium text-black">{selectedOrder.shipping_phone || selectedOrder.billing_phone}</p>
                      </div>
                      <div className="space-y-1">
                        <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Email</span>
                        <p className="text-lg font-medium text-black">{selectedOrder.shipping_email || selectedOrder.billing_email}</p>
                      </div>
                      <div className="space-y-1">
                        <span className="text-sm font-semibold text-gray-600 uppercase tracking-wide">Address</span>
                        <p className="text-lg font-medium text-black">
                          {selectedOrder.shipping_address || selectedOrder.billing_address}, {selectedOrder.shipping_city || selectedOrder.billing_city}, {selectedOrder.shipping_state || selectedOrder.billing_state} - {selectedOrder.shipping_pincode || selectedOrder.billing_pincode}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Items to Return */}
                  <div className="space-y-4 sm:space-y-6">
                    <h3 className="text-lg sm:text-xl font-bold text-black flex items-center gap-2 sm:gap-3">
                      <FaBox className="w-5 h-5 sm:w-6 sm:h-6" />
                      Items to Return
                    </h3>
                    <div className="bg-gray-100 border border-gray-300 rounded-xl p-3 sm:p-4">
                      <p className="text-xs sm:text-sm font-medium text-gray-700">
                        <strong>Note:</strong> All items from this order will be returned. You can select which items to exchange below.
                      </p>
                    </div>
                    <div className="space-y-3 sm:space-y-4">
                      {productExchangeFormData.selected_items.map((item, index) => (
                        <div key={index} className={`p-4 sm:p-6 border-2 rounded-xl transition-all duration-300 ${
                          item.selected 
                            ? 'border-black bg-gray-100 text-black shadow-lg' 
                            : 'border-blue-300 bg-white hover:border-blue-500'
                        }`}>
                          {/* Mobile Layout */}
                          <div className="block sm:hidden space-y-4">
                            <div className="flex items-start gap-3">
                              <input
                                type="checkbox"
                                checked={item.selected}
                                onChange={(e) => handleProductExchangeItemSelection(index, e.target.checked)}
                                className={`w-5 h-5 ${item.selected ? 'text-white' : 'text-black'} border-2 border-gray-300 rounded focus:ring-2 focus:ring-black flex-shrink-0 mt-1`}
                              />
                              <div className="flex-1 min-w-0">
                                <div className={`w-16 h-16 rounded-lg flex items-center justify-center mb-3 ${item.selected ? 'bg-white' : 'bg-gray-100'}`}>
                                  <FaBox className={`w-8 h-8 ${item.selected ? 'text-black' : 'text-gray-400'}`} />
                                </div>
                                <p className={`font-bold text-base ${item.selected ? 'text-white' : 'text-black'} mb-2`}>{item.name}</p>
                                <div className="space-y-1 text-sm">
                                  <p className={item.selected ? 'text-gray-300' : 'text-gray-600'}>SKU: {item.sku}</p>
                                  <p className={item.selected ? 'text-gray-300' : 'text-gray-600'}>Size: {item.size || item.variant_size || 'N/A'}</p>
                                  <p className={`font-bold ${item.selected ? 'text-white' : 'text-black'}`}>₹{item.selling_price}</p>
                                </div>
                              </div>
                            </div>
                            <div className="flex items-center justify-between pt-2 border-t border-gray-300">
                              <label className={`text-sm font-semibold ${item.selected ? 'text-gray-300' : 'text-gray-600'}`}>Quantity:</label>
                              <div className="flex items-center gap-2">
                                <input
                                  type="number"
                                  min="1"
                                  max={item.units}
                                  value={item.return_quantity}
                                  onChange={(e) => {
                                    const newQuantity = Math.max(0, Math.min(parseInt(e.target.value) || 0, item.units));
                                    setProductExchangeFormData((prev) => ({
                                      ...prev,
                                      selected_items: prev.selected_items.map((itm, idx) =>
                                        idx === index ? { ...itm, return_quantity: newQuantity } : itm
                                      ),
                                    }));
                                  }}
                                  className={`w-20 px-3 py-2 border-2 rounded-lg text-center font-bold text-sm ${
                                    item.selected 
                                      ? 'border-white bg-white text-black' 
                                      : 'border-gray-300 bg-white text-black'
                                  }`}
                                  disabled={!item.selected}
                                />
                                <span className={`text-sm font-medium ${item.selected ? 'text-gray-300' : 'text-gray-500'}`}>/ {item.units}</span>
                              </div>
                            </div>
                          </div>

                          {/* Desktop Layout */}
                          <div className="hidden sm:block">
                            <div className="flex items-center justify-between">
                              <div className="flex items-center gap-4">
                                <input
                                  type="checkbox"
                                  checked={item.selected}
                                  onChange={(e) => handleProductExchangeItemSelection(index, e.target.checked)}
                                 className={`w-6 h-6 ${item.selected ? 'text-black' : 'text-black'} border-2 border-gray-300 rounded focus:ring-2 focus:ring-black`}
                                />
                                <div className="flex-1">
                                  <div className="flex items-center gap-6">
                                    <div className={`w-20 h-20 rounded-xl flex items-center justify-center ${item.selected ? 'bg-white' : 'bg-gray-100'}`}>
                                      <FaBox className={`w-10 h-10 ${item.selected ? 'text-black' : 'text-gray-400'}`} />
                                    </div>
                                    <div>
                                      <p className={`font-bold text-lg ${item.selected ? 'text-black' : 'text-black'}`}>{item.name}</p>
                                      <div className="flex items-center gap-6 text-sm mt-1">
                                        <span className={item.selected ? 'text-gray-300' : 'text-gray-600'}>SKU: {item.sku}</span>
                                        <span className={item.selected ? 'text-gray-300' : 'text-gray-600'}>Size: {item.size || item.variant_size || 'N/A'}</span>
                                        <span className={`font-bold ${item.selected ? 'text-white' : 'text-black'}`}>₹{item.selling_price}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="flex items-center gap-3">
                                <label className={`text-sm font-semibold ${item.selected ? 'text-gray-300' : 'text-gray-600'}`}>Quantity:</label>
                                <input
                                  type="number"
                                  min="1"
                                  max={item.units}
                                  value={item.return_quantity}
                                  onChange={(e) => {
                                    const newQuantity = Math.max(0, Math.min(parseInt(e.target.value) || 0, item.units));
                                    setProductExchangeFormData((prev) => ({
                                      ...prev,
                                      selected_items: prev.selected_items.map((itm, idx) =>
                                        idx === index ? { ...itm, return_quantity: newQuantity } : itm
                                      ),
                                    }));
                                  }}
                                  className={`w-24 px-4 py-2 border-2 rounded-lg text-center font-bold ${
                                    item.selected 
                                      ? 'border-white bg-white text-black' 
                                      : 'border-gray-300 bg-white text-black'
                                  }`}
                                  disabled={!item.selected}
                                />
                                <span className={`text-sm font-medium ${item.selected ? 'text-gray-300' : 'text-gray-500'}`}>/ {item.units}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Exchange Products */}
                  <div className="space-y-4 sm:space-y-6">
                    <h3 className="text-lg sm:text-xl font-bold text-black flex items-center gap-2 sm:gap-3">
                      <FaBox className="w-5 h-5 sm:w-6 sm:h-6" />
                      Exchange Products
                    </h3>
                    <ProductSelectionStep
                      selectedProducts={selectedExchangeProducts}
                      setSelectedProducts={setSelectedExchangeProducts}
                      onAddProductClick={handleAddExchangeProduct}
                      neckLabelPrice={0}
                    />
                  </div>

                  {/* Shipping Method Selection */}
                  <div className="space-y-4 sm:space-y-6">
                    <h3 className="text-lg sm:text-xl font-bold text-black flex items-center gap-2 sm:gap-3">
                      <FaTruck className="w-5 h-5 sm:w-6 sm:h-6" />
                      Shipping Method
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6">
                      <label className={`p-4 sm:p-6 border-2 rounded-xl cursor-pointer transition-all duration-300 ${
                        exchangeShippingMethod === 'Surface' 
                          ? 'border-black bg-black text-white' 
                          : 'border-gray-300 hover:border-gray-500 bg-white'
                      }`}>
                        <input
                          type="radio"
                          name="shippingMethod"
                          value="Surface"
                          checked={exchangeShippingMethod === 'Surface'}
                          onChange={(e) => setExchangeShippingMethod(e.target.value)}
                          className="sr-only"
                        />
                        <div className="flex items-center justify-center gap-3">
                          <FaTruck className={`w-6 h-6 ${exchangeShippingMethod === 'Surface' ? 'text-white' : 'text-gray-600'}`} />
                          <p className="font-semibold text-lg">Surface</p>
                        </div>
                      </label>
                      <label className={`p-4 sm:p-6 border-2 rounded-xl cursor-pointer transition-all duration-300 ${
                        exchangeShippingMethod === 'Air' 
                          ? 'border-black bg-black text-white' 
                          : 'border-gray-300 hover:border-gray-500 bg-white'
                      }`}>
                        <input
                          type="radio"
                          name="shippingMethod"
                          value="Air"
                          checked={exchangeShippingMethod === 'Air'}
                          onChange={(e) => setExchangeShippingMethod(e.target.value)}
                          className="sr-only"
                        />
                        <div className="flex items-center justify-center gap-3">
                          <FaPlane className={`w-6 h-6 ${exchangeShippingMethod === 'Air' ? 'text-white' : 'text-gray-600'}`} />
                          <p className="font-semibold text-lg">Air</p>
                        </div>
                      </label>
                    </div>
                  </div>

                  {/* Cost Breakdown Summary */}
                  {selectedExchangeProducts.length > 0 && (
                    <div className="space-y-6">
                      <h3 className="text-xl font-bold text-black flex items-center gap-3">
                        <FaMoneyBillWave className="w-6 h-6" />
                        Cost Breakdown
                      </h3>
                      <div className="bg-gray-100 border-2 border-gray-300 rounded-xl p-8">
                        {(() => {
                          const breakdown = calculateExchangeCostBreakdown();
                          return (
                            <div className="space-y-4">
                              <div className="flex justify-between items-center py-2">
                                <span className="text-gray-700 font-medium">Items Subtotal:</span>
                                <span className="font-bold text-black text-lg">₹{breakdown.itemsSubtotal}</span>
                              </div>
                                {breakdown.neckLabelTotal > 0 && (
                                <div className="flex justify-between items-center py-2">
                                  <span className="text-gray-700 font-medium">Neck Labels (₹5 each):</span>
                                  <span className="font-bold text-black text-lg">₹{breakdown.neckLabelTotal}</span>
                                </div>
                              )}
                              <div className="flex justify-between items-center py-2">
                                <span className="text-gray-700 font-medium">Tax (5%):</span>
                                <span className="font-bold text-black text-lg">₹{breakdown.tax5}</span>
                              </div>
                              <div className="flex justify-between items-center py-2">
                                <span className="text-gray-700 font-medium">Base Shipping ({exchangeShippingMethod}):</span>
                                <span className="font-bold text-black text-lg">₹{breakdown.baseShipping}</span>
                              </div>
                              {breakdown.codShipping > 0 && (
                                <div className="flex justify-between items-center py-2">
                                  <span className="text-gray-700 font-medium">COD Shipping:</span>
                                  <span className="font-bold text-black text-lg">₹{breakdown.codShipping}</span>
                                </div>
                              )}
                              <div className="flex justify-between items-center py-2">
                                <span className="text-gray-700 font-medium">Shipping Tax (18%):</span>
                                <span className="font-bold text-black text-lg">₹{breakdown.shippingTax}</span>
                              </div>
                              <div className="border-t-2 border-gray-400 pt-4">
                                <div className="flex justify-between items-center text-2xl font-bold text-black">
                                  <span>Total Cost:</span>
                                  <span>₹{breakdown.totalCost}</span>
                                </div>
                              </div>
                            </div>
                          );
                        })()}
                      </div>
                    </div>
                  )}
                </div>

                {/* Modal Footer */}
                <div className="flex flex-col sm:flex-row justify-end gap-3 sm:gap-4 p-4 sm:p-8 border-t-2 border-gray-200 bg-white sticky bottom-0">
                  <button
                    onClick={closeProductExchangeModal}
                    className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-gray-200 text-black rounded-xl hover:bg-gray-300 transition-all duration-300 font-semibold border-2 border-gray-300"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleProductExchange}
                    disabled={
                      productExchangeLoading ||
                      selectedExchangeProducts.length === 0 ||
                      !productExchangeFormData.selected_items.some(
                        (item) => item.selected && item.return_quantity > 0
                      )
                    }
                    className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-black text-white rounded-xl hover:bg-gray-800 active:bg-gray-900 disabled:bg-gray-400 disabled:cursor-not-allowed transition-all duration-300 font-bold flex items-center justify-center gap-3 shadow-lg"
                  >
                    {productExchangeLoading ? (
                      <>
                        <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
                        Processing Exchange...
                      </>
                    ) : (
                      <>
                        <FaBox className="w-5 h-5" />
                        Process Exchange
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Product Selection Modal for Exchange */}
          <ProductSelectionModal
            isOpen={isProductModalOpen}
            onClose={() => setIsProductModalOpen(false)}
            products={exchangeProducts}
            onSelectProduct={handleSelectExchangeProduct}
          />
        </main>
      </div>
    </div>
  );
};

export default OrderManagement;